import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
  useLayoutEffect,
  Suspense,
  lazy,
} from "react";
import Sidebar from "../../components/Sidebar";
import { API_BASE_URL } from "../../app_url";
import { useDispatch, useSelector } from "react-redux";

import { MEDGAMMA_API_URL } from "@/app_url";



import { useConsultationRecorder } from "../../features/consultation-recorder";
import { normalizeUsage, reportAiUsage } from "../../services/aiUsageService";
import * as ConsultationConstants from "../../features/consultation-observations/consultation.constants";
import { createObservationEditorConfig } from "../../features/consultation-observations/observationEditor.config";
import {
  AbsenceModal,
  AppointmentCancellationModal,
  ChangePhoneNumberModal,
  CobotModal,
  ConfirmationModal,
  ConsultationHeader,
  ConsultationToolbar,
  DoctorSearchModal,
  FinishAppointmentModal,
  PopupConfirmationModal,
  ReferTemplateModal,
  RemindersModal,
  RescheduleAppointmentModal,
} from "../../features/consultation-observations/components";

// Lazy load tabs for better performance
const ObservationsTab = lazy(
  () => import("../../components/consultation/tabs/ObservationsTab"),
);
const NewPrescriptorTab = lazy(
  () => import("../../components/consultation/tabs/NewPrescriptorTab"),
);
const MessageTab = lazy(
  () => import("../../components/consultation/tabs/MessageTab"),
);
const PaymentManagementTab = lazy(
  () => import("../../components/consultation/tabs/PaymentManagementTab"),
);
const CobotTab = lazy(
  () => import("../../components/consultation/tabs/CobotTab"),
);


// ==========================
// Widgets Importation
// ===========================

const MedicalConditionWidget = lazy(
  () => import("@/components/consultation/widgets/MedicalConditionWidget"),
);

const MedicalBackgroundWidget = lazy(
  () => import("@/components/consultation/widgets/MedicalBackgroundWidget")
)

const PatientInformationsWidget = lazy(
  () => import("@/components/consultation/widgets/PatientInformationsWidget")
)



import rightArrowFillIcon from "../../assets/images/right-arrow-fill.svg";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { fetchDoctorAvailability, queryKeys, useProfileDetails, useDoctorExaminations } from "../../queries";
import {
  setCancelModalOpen,
  setSelectedCancelReason,
  setAbsenceModalOpen,
  setSelectedAbsenceReason,
  setRescheduleModalOpen,
  setSelectedRescheduleDate,
  setSelectedRescheduleTime,
  setSelectedRescheduleReason,
} from "../../store/slices/consultationUiSlice";

import "../../MedGemmaChat.css"; // Tu personnalises le CSS ici
import "./consultation-observations.css";

// Import organized service modules
import {
  appointmentDetailsApi,
  cancelAppointmentApi,
  rescheduleAppointmentApi,
  absenceAppointmentApi,
  getAppointmentMessageApi,
  readDoctorMessageApi,
  updatePriorityApi,
  choseChildApi,
} from "../../services/appointmentService";

import {
  addObservationApi,
} from "../../services/observationService";

import {
  fetchPrescriptionContentApi,
  getDoctorAllTemplateApi,
  printReferDocumentTemplateApi,
} from "../../services/prescriptionService";

import {
  listPrescriptorPrescriptionsByAppointmentApi,
  showPrescriptorPrescriptionApi,
} from "../../services/apiService";

import {
  doctorAddPatientMemberApi,
  doctorEditPhoneNumberApi,
  getDoctorForSearchApi,
  listDiagnosticsApi,
  getDiagnosticTitlesApi,

  fetchHolidayApi,
} from "../../services/patientService";

import {
  listDoctorProtocolsoins,
  listDoctorProtocolsoinss,
  updateDoctorProtocolsoin,
} from "../../services/stockProtocolService";

import { useNavigate, useParams } from "react-router";
import { format } from "date-fns";
import AddFamilyMemberModal from "./modals/AddFamilyMemberModal";
import PrescriptionTemplateModal from "../../components/consultation/tabs/components/modals/PrescriptionTemplateModal";

import LoadingPage from "../../components/LoadingPage";
import axios from "axios";
import moment from "moment";
import {
  chatMessgaeDateFormat,
  getFileExtension,
  isPreviousDateFromCurrent,
  useOnClickOutside,
  onLogout,
} from "../../utils/commonData";
import { useUserContext } from "../../context/UserContext";

const loadChartRequests = async () => {
  const module = await import("@/components/consultation/tabs/widgets/ChartWidget");
  return module.chartRequests;
};

const ConsultationObservations = ({ placeholder }) => {

  console.log("consultation observation rendered")
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const { userData, setUserData } = useUserContext();
  const navigate = useNavigate();

  const { appId } = useParams();

  // In-consultation audio recorder + AI suggestions. The panel is persisted in the
  // Redux `recorder` slot (survives navigation); leaving only stops the microphone.
  const recorder = useConsultationRecorder(appId);

  const editor = useRef(null);
  const editor2 = useRef(null);

  const reminderNoteEditorRef = useRef(null);
  const emojiPickerRef = useRef(null);
  const emojiPickerRef2 = useRef(null);
  const emojiPickerRef3 = useRef(null);
  const chatListRef = useRef(null);
  const prescriptionTabRef = useRef(null); // Ref for PrescriptionTab component
  const [isPeriodicVisit, setIsPeriodicVisit] = React.useState(false);

  // TODO need future care, this is just for hot fix


  // en haut du composant (avec les autres useState)
  const [showCobotBox, setShowCobotBox] = React.useState(false);

  // clic sur la flèche "charts"
  const ignoreUntilUserTypesRef = useRef(false);
  const [activeIndexes, setActiveIndexes] = useState([0, 1, 2]);
  const [chartPoints, setChartPoints] = useState([]); // TODO État pour stocker les points de charts, need to be removed
  const [cancelReason, setCancelReason] = useState();
  const [rescheduleReason, setRescheduleReason] = useState();
  const [modalBtnDis, setModalBtnDis] = useState(false);
  const [autofillEnabled, setAutofillEnabled] = useState(true);
  const [reschedulePopupShow, setReschedulePopupShow] = useState(false);
  const [showManageDropdown, setShowManageDropdown] = useState(false);
  const [calendarValue, setCalendarValue] = useState(new Date());
  const [availDates, setAvailDates] = useState();
  const [selectedTime, setSelectedTime] = useState();
  const [allDetails, setAllDetails] = useState();
  const { data: profileDetails } = useProfileDetails();
  const [allAppDetails, setAllAppDetails] = useState();
  const [appointmentDetails, setAppointmentDetails] = useState();
  const [screenLoading, setScreenLoading] = useState(true);
  const [skelLoading, setSkelLoading] = useState(false);
  const [futureDate, setFutureDate] = useState();
  const [bookedAppoinment, setBookedAppoinment] = useState();
  const [messageList, setMessageList] = useState([]);
  const [timeoutId, setTimeoutId] = useState(null);
  const [toDoctorSearchText, setToDoctorSearchText] = useState(null);
  const [toDoctorSearchList, setToDoctorSearchList] = useState();
  const [cobotText, setCobotText] = useState("");
  const [showCobotModal, setShowCobotModal] = useState(false);
  const [docsVisible, setDocsVisible] = useState(false); // État pour le toggle Docs & Stock
  const [scrollLocked, setScrollLocked] = useState(false); // État pour verrouiller le scroll

  const [toDoctorSearchLoader, setToDoctorSearchLoader] = useState(false);
  const [messageSenderObj, setMessageSenderObj] = useState();
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [alertShown, setAlertShown] = useState(false);
  const [messageText, setMessageText] = useState();
  const [messageFile, setMessageFile] = useState();
  const [messageSending, setMessageSending] = useState(false);
  const [toDoctorAndReferList, setToDoctorAndReferList] = useState({
    doctorList: [],
    referList: [],
  });


  const [selectedTemplateId, setSelectedTemplateId] = useState();
  const [showDeleteTempPopup, setShowDeleteTempPopup] = useState(false);
  const [deleteBtnDis, setDeleteBtnDis] = useState(false);
  const [prescriptionDate, setPrescriptionDate] = useState({
    name: "",
    date: new Date().toISOString().split("T")[0],
    age: "",
    gender: "",
  });

  const [age, setAge] = useState(
    appointmentDetails?.patient_details?.[0]?.age, // valeur par défaut si rien n'est disponible
  );
  // ex: function ConsultationObservations(props) { ... }
  const readOnly = false; // ✅ Disabled to allow editing - was: Boolean(typeof isPreviousDateFromCurrent === "function" ? isPreviousDateFromCurrent(appointmentDetails?.appointment_date) : false);

  const [examinationContent, setExaminationContent] = useState("");
  // Always-current mirror of examinationContent — lets callbacks with a frozen
  // closure (e.g. the memoised insertExamItem) read the latest value.
  const examinationContentRef = useRef("");
  examinationContentRef.current = examinationContent;
  const [otherNotesContent, setOtherNotesContent] = useState("");
  const [reminderNotesContent, setReminderNotesContent] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [showEmojiPicker1, setShowEmojiPicker1] = useState(false);
  const [showEmojiPicker2, setShowEmojiPicker2] = useState(false);

  const [medicalCondToggle, setMedicalCondToggle] = useState(false);
  const [selectedObservationItem, setSelectedObservationItem] = useState();
  const [selectedObservationPrescriptions, setSelectedObservationPrescriptions] =
    useState([]);
  const [selectedObservationPrescriptorModels, setSelectedObservationPrescriptorModels] =
    useState([]);


  const extractApiData = useCallback((response) => {
    return response?.data?.data ?? response?.data ?? null;
  }, []);

  const toDisplayString = useCallback((value) => {
    if (value === null || value === undefined) return "";
    return String(value).trim();
  }, []);

  const hasVisibleReminderText = useCallback((value) => {
    if (value === null || value === undefined) return false;
    const text = String(value)
      .replace(/<br\s*\/?>/gi, " ")
      .replace(/<[^>]*>/g, " ")
      .replace(/&nbsp;|\u00a0/gi, " ")
      .trim();
    return text !== "";
  }, []);

  const specialTypeLabelMap = useMemo(
    () => ({
      imagerie: "Imagerie",
      certificat: "Certificat",
      analyse: "Analyse",
      specialite: "Specialite",
      orientation: "Orientation",
    }),
    [],
  );

  const specialTypeKeys = useMemo(
    () => new Set(Object.keys(specialTypeLabelMap)),
    [specialTypeLabelMap],
  );

  const getSpecialTypeLabel = useCallback(
    (rawType) => {
      const normalized = toDisplayString(rawType).toLowerCase();
      return specialTypeLabelMap[normalized] || "Modele";
    },
    [specialTypeLabelMap, toDisplayString],
  );

  const parseStructuredContent = useCallback(
    (rawValue) => {
      if (rawValue === null || rawValue === undefined) {
        return { bodyHtml: "", items: [], parsed: false };
      }

      let parsedValue = rawValue;
      if (typeof rawValue === "string") {
        const trimmed = rawValue.trim();
        if (!trimmed) {
          return { bodyHtml: "", items: [], parsed: false };
        }

        const looksJson =
          (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
          (trimmed.startsWith("[") && trimmed.endsWith("]"));

        if (looksJson) {
          try {
            parsedValue = JSON.parse(trimmed);
          } catch {
            return { bodyHtml: toDisplayString(rawValue), items: [], parsed: false };
          }
        } else {
          return { bodyHtml: toDisplayString(rawValue), items: [], parsed: false };
        }
      }

      if (parsedValue && typeof parsedValue === "object") {
        const hasStructuredShape =
          Object.prototype.hasOwnProperty.call(parsedValue, "body_html") ||
          Object.prototype.hasOwnProperty.call(parsedValue, "items");

        if (!hasStructuredShape) {
          return { bodyHtml: toDisplayString(rawValue), items: [], parsed: false };
        }

        const bodyHtml = toDisplayString(parsedValue?.body_html);
        const items = Array.isArray(parsedValue?.items)
          ? parsedValue.items
            .map((item) => {
              if (item && typeof item === "object") {
                return toDisplayString(
                  item.name ||
                  item.label ||
                  item.code ||
                  item.group ||
                  item.group_name ||
                  item.value,
                );
              }
              return toDisplayString(item);
            })
            .filter(Boolean)
          : [];

        return { bodyHtml, items, parsed: true };
      }

      return { bodyHtml: toDisplayString(rawValue), items: [], parsed: false };
    },
    [toDisplayString],
  );

  const mapSpecialNotesToLines = useCallback(
    (rawNotes) => {
      const structured = parseStructuredContent(rawNotes);
      return [structured.bodyHtml, ...structured.items].filter(Boolean);
    },
    [parseStructuredContent],
  );

  const looksLikeHtml = useCallback((value) => {
    return /<\/?[a-z][\s\S]*>/i.test(toDisplayString(value));
  }, [toDisplayString]);

  const buildLegacyModelLines = useCallback(
    (presItem) => {
      if (!presItem || typeof presItem !== "object") return [];

      const csvToLines = (value) =>
        toDisplayString(value)
          .split(/,|\/\//)
          .map((line) => line.trim())
          .filter(Boolean);

      return [
        ...csvToLines(presItem?.medicine),
        ...csvToLines(presItem?.medical_test),
        ...mapSpecialNotesToLines(presItem?.notes),
        ...mapSpecialNotesToLines(presItem?.content),
        toDisplayString(presItem?.description),
      ].filter(Boolean);
    },
    [mapSpecialNotesToLines, toDisplayString],
  );

  const isOrdonnanceLegacyItem = useCallback(
    (presItem) => {
      const templateName = toDisplayString(presItem?.template_name).toLowerCase();
      const categoryName = toDisplayString(presItem?.category).toLowerCase();

      if (templateName.includes("ordonnance") || categoryName.includes("ordonnance")) {
        return true;
      }

      const contentHints = [
        toDisplayString(presItem?.prescription_body),
        toDisplayString(presItem?.medicine),
        toDisplayString(presItem?.medical_test),
      ].filter(Boolean);

      return contentHints.length > 0 && !specialTypeKeys.has(templateName) && !specialTypeKeys.has(categoryName);
    },
    [specialTypeKeys, toDisplayString],
  );

  const mapPrescriptorLineToText = useCallback(
    (line) => {
      if (!line || typeof line !== "object") return "";

      if (line.type === "test_line") {
        const tests = Array.isArray(line.tests)
          ? line.tests
            .map((test) => toDisplayString(test?.name || test?.label || test))
            .filter(Boolean)
          : [];
        return tests.length ? `Tests: ${tests.join(", ")}` : "Tests";
      }

      if (line.type === "condition_line") {
        const expression = toDisplayString(line.expression);
        const actionType = toDisplayString(line.action_type);
        const actionMedication = toDisplayString(line.action_medication);
        return [expression, actionType, actionMedication]
          .filter(Boolean)
          .join(" | ");
      }

      const duration =
        toDisplayString(line.duree_unite) === "calendar"
          ? [
            toDisplayString(line.duree_calendar_start)
              ? `j${toDisplayString(line.duree_calendar_start)}`
              : "",
            toDisplayString(line.duree_calendar_end)
              ? `j${toDisplayString(line.duree_calendar_end)}`
              : "",
          ]
            .filter(Boolean)
            .join(" -> ")
          : [toDisplayString(line.duree_valeur), toDisplayString(line.duree_unite)]
            .filter(Boolean)
            .join(" ");

      return [
        [toDisplayString(line.dose), toDisplayString(line.unite)]
          .filter(Boolean)
          .join(" "),
        toDisplayString(line.frequence),
        toDisplayString(line.voie),
        toDisplayString(line.moment),
        toDisplayString(line.repas),
        duration,
        (() => {
          const cond = toDisplayString(line.condition).trim();
          if (!cond) return "";
          return cond.toLowerCase().startsWith("si ") ? cond : `si ${cond}`;
        })(),
        toDisplayString(line.renouvellement),
        toDisplayString(line.notes),
      ]
        .filter(Boolean)
        .join(" | ");
    },
    [toDisplayString],
  );

  const mapPrescriptorBlockToTexts = useCallback(
    (block) => {
      if (!block || typeof block !== "object") return [];

      const medicationName = toDisplayString(
        block.medication_name || block?.medicament?.name,
      );
      const quantity = toDisplayString(block.quantity || block.quantite);
      const quantityUnit = toDisplayString(block.quantity_unit || block.type_quantite);

      const header = [
        medicationName,
        quantity ? `Qte: ${[quantity, quantityUnit].filter(Boolean).join(" ")}` : "",
      ]
        .filter(Boolean)
        .join(" - ");

      const lines = Array.isArray(block.lines)
        ? block.lines.map(mapPrescriptorLineToText).filter(Boolean)
        : [];

      const children = Array.isArray(block.children)
        ? block.children.flatMap(mapPrescriptorBlockToTexts)
        : [];

      return [header, ...lines, ...children].filter(Boolean);
    },
    [mapPrescriptorLineToText, toDisplayString],
  );

  useEffect(() => {
    const loadSelectedObservationPrescriptions = async () => {
      const appointmentId = selectedObservationItem?.appointment_id;
      if (!appointmentId) {
        setSelectedObservationPrescriptions([]);
        setSelectedObservationPrescriptorModels([]);
        return;
      }

      const normalizedAppointmentId = String(appointmentId);

      try {
        const formData = new FormData();
        formData.append("appointment_id", appointmentId);
        const response = await fetchPrescriptionContentApi(formData);
        const rawPrescriptions =
          response?.data?.res === true && Array.isArray(response?.data?.data)
            ? response.data.data
            : [];
        const prescriptions = rawPrescriptions.filter((item) => {
          const itemAppointmentId =
            item?.appointment_id ??
            item?.appointmentId ??
            item?.appointment?.id ??
            null;

          if (!itemAppointmentId) return true;
          return String(itemAppointmentId) === normalizedAppointmentId;
        });
        setSelectedObservationPrescriptions(prescriptions);
      } catch (error) {
        console.error(
          "loadSelectedObservationPrescriptions error:",
          error,
        );
        setSelectedObservationPrescriptions([]);
      }

      try {
        const listResponse = await listPrescriptorPrescriptionsByAppointmentApi(
          appointmentId,
          {
            per_page: 200,
          },
        );

        const scopedData = extractApiData(listResponse);
        const listItems = Array.isArray(scopedData?.items)
          ? scopedData.items
          : Array.isArray(scopedData)
            ? scopedData
            : [];

        const detailedPrescriptions = await Promise.all(
          listItems
            .filter((item) => Boolean(item?.id))
            .map(async (item) => {
              try {
                const detailResponse = await showPrescriptorPrescriptionApi(
                  item.id,
                );
                return extractApiData(detailResponse) || item;
              } catch (error) {
                return item;
              }
            }),
        );

        const models = detailedPrescriptions
          .map((prescription) => {
            const entries = Array.isArray(prescription?.entries)
              ? prescription.entries
              : [];
            const blocks = entries.flatMap((entry) =>
              Array.isArray(entry?.blocks) ? entry.blocks : [],
            );
            const standardLines = blocks.flatMap(mapPrescriptorBlockToTexts);
            const specialLines = mapSpecialNotesToLines(prescription?.notes);
            const specialType = toDisplayString(prescription?.title).toLowerCase();
            const specialTypeLabel = getSpecialTypeLabel(specialType);
            const isSpecialModel = Boolean(specialTypeLabelMap[specialType]);
            const modelTitle = isSpecialModel
              ? `${specialTypeLabel} #${prescription?.id || ""}`.trim()
              : `Modele Prescriptor #${prescription?.id || ""}`.trim();
            const lines = [...standardLines, ...specialLines].filter(Boolean);

            return {
              id: prescription?.id,
              appointmentId:
                prescription?.appointment_id ||
                prescription?.appointmentId ||
                prescription?.appointment?.id ||
                null,
              specialType,
              title: modelTitle,
              lines: lines.filter(Boolean),
            };
          })
          .filter((model) => model.lines.length > 0)
          .filter((model) => {
            if (!model?.appointmentId) return true;
            return String(model.appointmentId) === normalizedAppointmentId;
          })
          .filter((model) => !specialTypeKeys.has(toDisplayString(model?.specialType).toLowerCase()));

        setSelectedObservationPrescriptorModels(models);
      } catch (error) {
        console.error(
          "loadSelectedObservationPrescriptorModels error:",
          error,
        );
        setSelectedObservationPrescriptorModels([]);
      }
    };

    if (!selectedObservationItem) {
      setSelectedObservationPrescriptions([]);
      setSelectedObservationPrescriptorModels([]);
      return;
    }

    loadSelectedObservationPrescriptions();
  }, [
    selectedObservationItem,
    extractApiData,
    getSpecialTypeLabel,
    mapPrescriptorBlockToTexts,
    mapSpecialNotesToLines,
    specialTypeKeys,
    specialTypeLabelMap,
    toDisplayString,
  ]);
  const [prevValues, setPrevValues] = useState({
    medicalCondTitle: "",
    examinationContent: "",
    otherNotesContent: "",
    reminderNotesContent: "",
  });
  const [referTemplateList, setReferTemplateList] = useState();
  const [selectedReferTemplate, setSeletedReferTemplate] = useState();
  const [referTemplateMessage, setReferTemplateMessage] = useState();
  const [referTextTemplateMessage, setReferTextTemplateMessage] = useState();
  const [addPatientObject, setAddPatientObject] = useState();
  const [showChangePhoneModal, setShowChangePhoneModal] = useState(false);
  const [newPhoneNumber, setNewPhoneNumber] = useState();
  const [choosePatientConfirmPopup, setChoosePatientConfirmPopup] =
    useState(false);
  const [selectedKidDetails, setSelectedKidDetails] = useState();
  const [selectedDates, setSelectedDates] = useState([]);
  const [absensePopupOpen, setAbsensePopupOpen] = useState(false);
  const [absenseReason, setAbsenseReason] = useState();
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [messages, setMessages] = useState([
    {
      text: "Hello! I'm MedGemma, a medical AI assistant. How can I help you today?",
      sender: "assistant",
    },
  ]);
  const [imageBase64, setImageBase64] = useState(null);
  const [isTyping, setIsTyping] = useState(false);
  const [warmed, setWarmed] = useState(false);
  const [warmingUp, setWarmingUp] = useState(false);
  const [sessionId, setSessionId] = useState(null);


  // Refs
  const chatLogRef = useRef(null);
  const idleTimerRef = useRef(null);

  // Constants
  const idleTime = 90000; // 90 seconds
  const lastWakeupAtRef = useRef(0);
  // Suggestions pour l'autocomplete


  // --- extraire un "token" à partir de la fin du contenu pour déclencher l’autofill


  useEffect(() => {
    if (scrollLocked) {
      // Désactiver le scroll
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
      document.body.style.top = `-${window.scrollY}px`;
    } else {
      // Réactiver le scroll et restaurer la position
      const scrollY = document.body.style.top;
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.top = "";
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
      }
    }
  }, [scrollLocked]);


  const sendWakeupIfNeeded = useCallback(async () => {
    const now = Date.now();
    if (now - lastWakeupAtRef.current < ConsultationConstants.MEDGEMMA_WAKEUP.cooldownMs) {
      return; // cooldown pas encore écoulé
    }
    lastWakeupAtRef.current = now;

    try {
      const res = await fetch(ConsultationConstants.MEDGEMMA_WAKEUP.url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          session_id: sessionId,
          messages: [{ role: "user", content: ConsultationConstants.MEDGEMMA_WAKEUP.text }],
        }),
      });

      // Backend renvoie 204 No Content -> c’est normal (réveil silencieux)
      if (res.status !== 204 && !res.ok) {
        console.error("Wakeup failed with status:", res.status);
      }
    } catch (e) {
      console.error("Wakeup fetch error:", e);
    }
  }, [sessionId]);

  // Effet pour gérer le scroll
  useEffect(() => {
    if (scrollLocked) {
      // Désactiver le scroll
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
      document.body.style.top = `-${window.scrollY}px`;
    } else {
      // Réactiver le scroll et restaurer la position
      const scrollY = document.body.style.top;
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.top = "";
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
      }
    }
  }, [scrollLocked]);

  // Initialize session on component mount
  useEffect(() => {
    initSession();
    loadChatHistory();
    return () => {
      // Cleanup on unmount
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    };
  }, []);

  // Scroll to bottom when messages change
  useEffect(() => {
    if (chatLogRef.current) {
      chatLogRef.current.scrollTop = chatLogRef.current.scrollHeight;
    }
  }, [messages]);

  // state
  const [medicalCondTitle, setMedicalCondTitle] = useState("");

  // Initialize session
  const initSession = () => {
    const storedSessionId = localStorage.getItem(
      `${ConsultationConstants.MEDGEMMA_STORAGE_PREFIX}session_id`,
    );
    if (storedSessionId && isValidSessionId(storedSessionId)) {
      setSessionId(storedSessionId);
    } else {
      const newSessionId = generateSessionId();
      setSessionId(newSessionId);
      localStorage.setItem(`${ConsultationConstants.MEDGEMMA_STORAGE_PREFIX}session_id`, newSessionId);
    }
  };



  const isValidSessionId = (id) => {
    return id && typeof id === "string" && id.startsWith("sess_");
  };

  const generateSessionId = () => {
    return (
      "sess_" + Date.now() + "_" + Math.random().toString(36).substring(2, 15)
    );
  };

  // Load chat history from localStorage
  const loadChatHistory = () => {
    try {
      const savedHistory = localStorage.getItem(
        `${ConsultationConstants.MEDGEMMA_STORAGE_PREFIX}history_${sessionId}`,
      );
      if (savedHistory) {
        const loadedMessages = JSON.parse(savedHistory);
        setMessages(loadedMessages);
      }
    } catch (e) {
      console.error("Failed to load conversation history:", e);
    }
  };

  // Save current conversation to localStorage
  const saveCurrentContext = () => {
    if (messages.length > 0) {
      try {
        const messagesToSave =
          messages.length > ConsultationConstants.MAX_LOCAL_CHAT_HISTORY
            ? messages.slice(-ConsultationConstants.MAX_LOCAL_CHAT_HISTORY)
            : messages;

        localStorage.setItem(
          `${ConsultationConstants.MEDGEMMA_STORAGE_PREFIX}history_${sessionId}`,
          JSON.stringify(messagesToSave),
        );
      } catch (e) {
        console.error("Failed to save conversation to localStorage:", e);
        if (e.name === "QuotaExceededError") {
          clearOldLocalStorageData();
        }
      }
    }
  };

  const clearOldLocalStorageData = () => {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (
        key.startsWith(`${ConsultationConstants.MEDGEMMA_STORAGE_PREFIX}history_`) &&
        !key.includes(sessionId)
      ) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));
  };
  function debounce(fn, delay = 300) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), delay);
    };
  }

  // Warm up model
  const warmUpModel = async (silent = false) => {
    if (warmingUp) return;

    setWarmingUp(true);
    if (!silent) setIsTyping(true);

    try {
      const response = await fetchChat([], null, true);
      setWarmed(response && !response.error);
      if (response?.session_id) updateSessionId(response.session_id);
    } catch (error) {
      setWarmed(false);
    } finally {
      setWarmingUp(false);
      if (!silent) setIsTyping(false);
    }
  };

  const updateSessionId = (newSessionId) => {
    if (newSessionId && newSessionId !== sessionId) {
      setSessionId(newSessionId);
      localStorage.setItem(`${ConsultationConstants.MEDGEMMA_STORAGE_PREFIX}session_id`, newSessionId);
    }
  };

  const callOpenAIBackend = async ({
    message,
    model = "gpt-5-nano",
    image = null,
  }) => {
    const url = `${API_BASE_URL}openai/responses`;

    const body = { message, model };
    if (image) body.image = image; // base64 envoyé au backend

    const resp = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    if (!resp.ok) {
      const text = await resp.text().catch(() => null);
      throw new Error(
        `OpenAI backend error: ${resp.status} ${text || resp.statusText}`,
      );
    }

    const data = await resp.json();

    // Track token usage for the admin dashboard (best-effort, never blocks).
    if (data?.raw?.usage) {
      reportAiUsage({
        feature: "cobot",
        model: data?.raw?.model || model || "gpt-5-nano",
        ...normalizeUsage(data.raw.usage),
        appointmentId: appId,
      });
    }

    return data;
  };

  const fetchChat = async (messagesArray, image = null, ping = false) => {
    // Build body for proxy (medgemma)
    const bodyForProxy = {
      messages: Array.isArray(messagesArray) ? messagesArray : [],
      ping,
      session_id: sessionId,
    };

    // Handle image data
    if (image) {
      if (typeof image === "string" && image.startsWith("data:image/")) {
        bodyForProxy.image = image;
      } else if (image instanceof File) {
        bodyForProxy.image = await fileToDataURL(image);
      }
    }

    // Force summarization logic
    const convLength = Array.isArray(bodyForProxy.messages)
      ? bodyForProxy.messages.length
      : 0;
    if (convLength >= 10 || (convLength > 0 && convLength % 5 === 0)) {
      bodyForProxy.force_summarize = true;
      console.log(
        "🧠 force_summarize=true sent to proxy (convLength=",
        convLength,
        ")",
      );
    }

    // ChatGPT path
    if (selectedModel === "chatgpt") {
      const uiMsgs =
        Array.isArray(messagesArray) && messagesArray.length > 0
          ? messagesArray
          : typeof messages !== "undefined" && Array.isArray(messages)
            ? messages
            : [];

      // Normalize to OpenAI format and FILTER OUT system messages from the conversation
      const openAIMessages = uiMsgs
        .filter((msg) => msg.role !== "system") // Remove system messages from conversation history
        .map((m) => {
          if (m.role && m.content !== undefined) {
            return {
              role: m.role,
              content: m.content,
            };
          }
          return {
            role: m.sender === "user" ? "user" : "assistant",
            content: m.text || "",
          };
        });

      try {
        // For ChatGPT, include system instruction separately, not in messages
        const data = await callOpenAIBackend({
          messages: openAIMessages,
          systemInstruction:
            "Be clear and helpful and you are speaking to a doctor.", // Pass system instruction separately
          model: "gpt-5.4",
          "service-tier": "priority",
          image,
        });

        const normalized = {
          choices: [
            {
              message: {
                content:
                  data.output_text ?? data.raw?.output_text ?? "No response",
              },
            },
          ],
          raw: data.raw ?? data,
        };

        // Update session if provided
        if (normalized.raw?.session_id)
          updateSessionId(normalized.raw.session_id);

        // Handle summary
        const summaryText =
          normalized.raw?.summary ||
          normalized.raw?.summary_text ||
          normalized.summary ||
          normalized.summary_text ||
          null;

        if (summaryText) {
          saveSummaryLocal(summaryText);
          sendSummaryToServer(summaryText);
        }

        // Save local context
        if (!ping) saveCurrentContext();

        return normalized;
      } catch (err) {
        console.error("OpenAI backend error:", err);
        throw err;
      }
    }

    // MedGemma path (proxy) - FILTER OUT system messages
    try {
      const apiUrl = MEDGAMMA_API_URL;

      // Clean messages for MedGemma - remove ALL system messages
      const cleanMessages = bodyForProxy.messages.filter(
        (msg) => msg.role !== "system",
      );

      bodyForProxy.messages = cleanMessages;

      const resp = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bodyForProxy),
      });

      if (!resp.ok) {
        // Handle silent wakeup response (204 No Content)
        if (resp.status === 204) {
          console.log("Silent wakeup completed");
          return { choices: [{ message: { content: "" } }] };
        }
        throw new Error(`HTTP error! status: ${resp.status}`);
      }

      const json = await resp.json();

      // Update session
      if (json?.session_id) updateSessionId(json.session_id);

      // Handle summary
      const summaryText =
        json?.summary ||
        json?.summary_text ||
        json?.raw?.summary ||
        json?.raw?.summary_text ||
        null;

      if (summaryText) {
        saveSummaryLocal(summaryText);
        sendSummaryToServer(summaryText);
      }

      // Save conversation locally
      if (!ping) saveCurrentContext();

      return json;
    } catch (error) {
      console.error("Fetch error:", error);
      throw error;
    }
  };

  // Helper function to convert File to Data URL
  const fileToDataURL = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };
  // Helper functions (you'll need to implement these based on your needs)
  const saveSummaryLocal = (summary) => {
    // Save summary to localStorage or state
    try {
      localStorage.setItem("chat_summary", summary);
    } catch (e) {
      console.warn("Could not save summary to localStorage");
    }
  };

  const sendSummaryToServer = (summary) => {
    // Send summary to your backend if needed
    console.log("Summary to send to server:", summary);
  };




  // Reset idle timer
  const resetIdleTimer = () => {
    if (idleTimerRef.current) clearTimeout(idleTimerRef.current);

    idleTimerRef.current = setTimeout(() => {
      if (isOpen && !warmed && !warmingUp) {
        warmUpModel(true);
      }
    }, idleTime);
  };



  // Toggle chat window
  const toggleChat = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      resetIdleTimer();
      if (!warmed && !warmingUp) warmUpModel(true);
    } else {
      setImageBase64(null);
    }
  };


  useOnClickOutside(emojiPickerRef, () => setShowEmojiPicker(false));
  useOnClickOutside(emojiPickerRef2, () => setShowEmojiPicker1(false));
  useOnClickOutside(emojiPickerRef3, () => setShowEmojiPicker2(false));

  const daysarray = [];
  for (let i = 1; i <= 31; i++) {
    daysarray.push(i < 10 ? "0" + i : i);
  }

  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 100;
  const years = [];

  for (let year = startYear; year <= currentYear; year++) {
    years.push(year);
  }

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const toggleAccordion = (index) => {
    if (activeIndexes.includes(index)) {
      setActiveIndexes(activeIndexes.filter((i) => i !== index));
    } else {
      setActiveIndexes([...activeIndexes, index]);
    }
  };
  // utils
  // helpers (à placer en haut du composant)
  // Tab visibility
  const [activeTab, setActiveTab] = useState("observations");

  const handleTabClick = (tab) => {
    setActiveTab(tab);

  };
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);

  const toggleProfileMoadl = () => {
    setShowProfileModal(!showProfileModal);
  };

  const [showRemoveMedicalBackgroundItem, setShowRemoveMedicalBackgroundItem] =
    useState(false);

  const toggleRemoveMedicalBackgroundItem = () => {
    setShowRemoveMedicalBackgroundItem(!showRemoveMedicalBackgroundItem);
  };

  const [showMedicalReport, setShowMedicalReport] = useState(false);

  const toggleMedicalReport = () => {
    setShowMedicalReport(!showMedicalReport);
  };

  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [showReferTemplateModal, setShowReferTemplateModal] = useState(false);
  const [showOtherTemplateDropdown, setShowOtherTemplateDropdown] =
    useState(false);

  const toggleTemplateModal = () => {
    setShowTemplateModal(!showTemplateModal);
  };


  // États pour la modale d'ajout

  const [popupBtnDis, setPopupBtnDis] = useState(false);
  const [diagLoaded, setDiagLoaded] = useState(false);



  const [showRemindersModal, setShowRemindersModal] = useState(false);

  const toggleRemindersModal = () => {
    setShowRemindersModal(!showRemindersModal);
  };

  const [showCancelAppointmnet, setShowCancelAppointmnet] = useState(false);

  const toggleCancelAppointmnet = () => {
    const next = !showCancelAppointmnet;
    setShowCancelAppointmnet(next);
    dispatch(setCancelModalOpen(next));
  };

  const [showReferDoctorModal, setShowReferDoctorModal] = useState(false);

  const [showToDoctorModal, setShowToDoctorModal] = useState(false);

  const toggleReferDoctor = () => {
    setShowReferDoctorModal(!showReferDoctorModal);
  };

  const getProfileDetails = async () => {
    // Profile is retrieved and cached across the app via TanStack Query (useProfileDetails)
    const docId = profileDetails?.id || allDetails?.id;
    if (docId && calendarValue) {
      setSelectedTime(null);
      getDateAvailabilityList(
        docId,
        format(calendarValue, "yyyy-MM-dd"),
        "For online consultation",
      );
    }
  };

  const handleCancelAppointment = async () => {
    if (!cancelReason) {
      toast.warning("Please select cancel reason.", { autoClose: 1500 });
    } else {
      try {
        setModalBtnDis(true);
        const fd = new FormData();
        fd.append("id", appId);
        fd.append("reason", cancelReason);

        let response = await cancelAppointmentApi(fd);
        if (response) {
          if (response.data.res === true) {
            toast.success(
              response.data.msg
                ? response.data.msg
                : "Appointment cancelled successfully.",
              { autoClose: 1500 },
            );
            setShowCancelAppointmnet(false);
            dispatch(setCancelModalOpen(false));
            navigate("/doctor/appointments");
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
        setModalBtnDis(false);
      } catch (error) {
        setModalBtnDis(false);
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {
          autoClose: 1500,
        });
      }
    }
  };

  const handleDateClick = async (date) => {
    const newDate = date.toDateString();
    setCalendarValue(date);
    const docId = profileDetails?.id || allDetails?.id;
    if (docId) {
      getDateAvailabilityList(
        docId,
        format(date, "yyyy-MM-dd"),
        "For online consultation",
      );
    }
  };

  const tileClassName = ({ date }) => {
    const formattedDate = date.toDateString();
    return calendarValue === formattedDate ? "highlighted-date" : null;
  };

  const getHolidays = async (date) => {
    if (date) {
      try {
        let formData = new FormData();
        formData.append("day", date);

        let response = await fetchHolidayApi(formData);
        if (response) {
          if (response.data.res === true) {
            const formattedDates = response.data.data.map((item) =>
              new Date(item.holiday_date).toDateString(),
            );
            setSelectedDates(formattedDates);
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {
          autoClose: 1500,
        });
      }
    }
  };

  const handleActiveStartDateChange = ({ action, activeStartDate, view }) => {
    if (action === "prev" || action === "next") {
      const formattedDate = format(activeStartDate, "yyyy-MM");
      getHolidays(formattedDate);
    }
  };

  const getDateAvailabilityList = async (
    docId,
    date,
    consultationType = "For online consultation",
  ) => {
    if (docId && date && consultationType) {
      try {
        setSkelLoading(true);
        const availability = await fetchDoctorAvailability(
          queryClient,
          docId,
          date,
          consultationType,
        );

        if (availability?.res) {
          setAvailDates(availability.availableSlots);
          setBookedAppoinment(availability.bookedSlots);
          if (availability.futureDays) {
            const tempFutureDate = moment().add(
              parseInt(availability.futureDays, 10),
              "days",
            );
            setFutureDate(tempFutureDate);
          }
          setSelectedTime(null);
          setRescheduleReason(null);
          dispatch(setSelectedRescheduleDate(date));
          dispatch(setSelectedRescheduleTime(null));
          dispatch(setSelectedRescheduleReason(null));
        } else if (availability?.msg) {
          toast.error(availability.msg, { autoClose: 1500 });
        }
        setSkelLoading(false);
      } catch (error) {
        setSkelLoading(false);
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {
          autoClose: 1500,
        });
      }
    }
  };

  const handleReschedule = async () => {
    if (!selectedTime) {
      toast.warning("Please select a time.", { autoClose: 1500 });
    } else if (!rescheduleReason) {
      toast.warning("Please select reschedule reason.", { autoClose: 1500 });
    } else {
      try {
        setModalBtnDis(true);
        const fd = new FormData();
        fd.append("id", appId);
        fd.append("reason", rescheduleReason);
        fd.append("appointment_date", format(calendarValue, "yyyy-MM-dd"));
        fd.append("time", selectedTime);

        let response = await rescheduleAppointmentApi(fd);
        if (response) {
          if (response.data.res === true) {
            toast.success(
              response.data.msg
                ? response.data.msg
                : "Appointment rescheduled successfully.",
              { autoClose: 1500 },
            );
            // Targeted invalidation of availability cache on reschedule
            const docId = profileDetails?.id || allDetails?.id;
            if (docId && calendarValue) {
              queryClient.invalidateQueries({
                queryKey: queryKeys.appointments.availability(
                  docId,
                  format(calendarValue, "yyyy-MM-dd"),
                  "For online consultation",
                ),
              });
            }
            if (docId) {
              getDateAvailabilityList(
                docId,
                format(calendarValue, "yyyy-MM-dd"),
                "For online consultation",
              );
            }
            setReschedulePopupShow(false);
            dispatch(setRescheduleModalOpen(false));
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
        setModalBtnDis(false);
      } catch (error) {
        setModalBtnDis(false);
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {
          autoClose: 1500,
        });
      }
    }
  };

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    // Adjust age if the birthday has not occurred yet this year
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const getAppointmentDetails = async () => {
    try {
      console.log("loading...")
      setScreenLoading(true);

      const fd = new FormData();
      fd.append("id", appId);

      let response = await appointmentDetailsApi(fd);
      console.log("response is", response)
      if (response && response.data.res === true) {
        // Vérification du doctor
        if (
          parseInt(userData?.users?.id) !==
          parseInt(response.data.data[0]?.doctor_details?.id)
        ) {
          navigate("/404");
          return;
        }

        setAppointmentDetails(response.data.data[0]);
        setAllAppDetails(response.data);

        // Récupération du patient ID
        const patientId = response.data.data[0]?.patient_details?.[0]?.id;
        if (!patientId) {
          console.warn("⚠️ Patient ID is missing, API call skipped");
        }

        // Remplissage des observations
        if (response.data.observations?.length > 0) {
          const obs = response.data.observations[0];
          setMedicalCondTitle(obs.medical_condition_title || "");
          setExaminationContent(obs.examination || "");
          setOtherNotesContent(obs.other_notes || "");
          console.log("obs.other_notes", otherNotesContent);
          setReminderNotesContent(obs.reminder_note || "");

          setPrevValues({
            medicalCondTitle: obs.medical_condition_title || "",
            examinationContent: obs.examination || "",
            otherNotesContent: obs.other_notes || "",
            reminderNotesContent: obs.reminder_note || "",
          });
        }

        // Calcul de l’âge
        let tempAge = 0;
        if (response.data.data[0]?.patient_details[0]?.dob) {
          tempAge = calculateAge(
            response.data.data[0]?.patient_details[0]?.dob,
          );
        }
        setPrescriptionDate((prev) => ({
          ...prev,
          name: `${response.data.data[0]?.patient_details[0]?.first_name || ""} ${response.data.data[0]?.patient_details[0]?.last_name || ""}`,
          age: tempAge,
          gender: response.data.data[0]?.patient_details[0]?.gender,
        }));
      } else {
        toast.error(response?.data?.msg || "Something went wrong in server.", {
          autoClose: 1500,
        });
      }
    } catch (error) {
      console.error(error);
      if (error.response?.status === 403) {
        toast.error(error.response?.data?.message || "Votre abonnement a expiré. Veuillez renouveler votre abonnement pour continuer.", {
          autoClose: 3000,
        });
      } else {
        toast.error("Something went wrong in server. Please try again.", {
          autoClose: 1500,
        });
      }
    } finally {
      setScreenLoading(false);
    }
  };

  const generateTimeSlots = (startTime, endTime, interval, timeSlotType) => {
    const slots = [];

    // Create moment objects for the start and end times
    const startMoment = moment(startTime, "HH:mm");
    const endMoment = moment(endTime, "HH:mm");

    // Loop to generate time slots
    while (startMoment.isBefore(endMoment)) {
      slots.push(startMoment.format("HH:mm")); // Format as HH:mm
      if (timeSlotType === "Minute") {
        startMoment.add(interval, "minutes"); // Increment by the interval in minutes
      } else if (timeSlotType === "Hour") {
        startMoment.add(interval, "hours"); // Increment by the interval in hours
      }
    }

    // Remove the last slot if it equals the end time
    if (slots[slots.length - 1] === endMoment.format("HH:mm")) {
      slots.pop();
    }
    return slots;
  };

  const handleSelectTime = (time) => {
    if (time.has_interval === 1) {
      let title = time?.start_time + "-" + time?.end_time;
      let count = 0;
      bookedAppoinment.forEach((element) => {
        if (element === title) {
          count += 1;
        }
      });

      if (count >= time?.visitor) {
        toast.warning(
          "Oops! This time slot is full. Please try on different time.",
          { autoClose: 1500 },
        );
        setSelectedTime(null);
        dispatch(setSelectedRescheduleTime(null));
      } else {
        setSelectedTime(title);
        dispatch(setSelectedRescheduleTime(title));
      }
    } else {
      if (bookedAppoinment.includes(time)) {
        toast.warning(
          "Oops! This time slot is already taken. Please choose a different slot.",
          { autoClose: 1500 },
        );
        setSelectedTime(null);
        dispatch(setSelectedRescheduleTime(null));
      } else {
        setSelectedTime(time);
        dispatch(setSelectedRescheduleTime(time));
      }
    }
  };


  const handleChangePriority = async (value) => {
    try {
      setScreenLoading(true);
      const fd = new FormData();
      fd.append("id", appId);
      fd.append(
        "patient_id",
        allAppDetails?.data[0]?.patient_details[0]?.id | "",
      );
      fd.append("type", "priority");
      fd.append("value", value);
      let response = await updatePriorityApi(fd);
      if (response) {
        if (response.data.res === true) {
          let tempObj = { ...allAppDetails };
          tempObj.data[0].patient_details[0].priority = value;
          setAllAppDetails(tempObj);
          toast.success(
            response.data.msg ? response.data.msg : "Updated successfully.",
            { autoClose: 1500 },
          );
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
    } finally {
      setScreenLoading(false);
    }
  };

  const handleChangePrioritySupport = async (value) => {
    try {
      setScreenLoading(true);
      const fd = new FormData();
      fd.append("id", appId);
      fd.append(
        "patient_id",
        allAppDetails?.data[0]?.patient_details[0]?.id | "",
      );
      fd.append("type", "supports");
      fd.append("value", value);
      let response = await updatePriorityApi(fd);
      if (response) {
        if (response.data.res === true) {
          let tempObj = { ...allAppDetails };
          tempObj.data[0].patient_details[0].support = value;
          setAllAppDetails(tempObj);
          toast.success(
            response.data.msg ? response.data.msg : "Updated successfully.",
            { autoClose: 1500 },
          );
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
    } finally {
      setScreenLoading(false);
    }
  };

  const handleToDoctorSearchTextChange = (value) => {
    setToDoctorSearchText(value);
    // setShowList(event.target.value.length > 0);

    // Clear the existing timeout
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    // Set a new timeout for debouncing
    const newTimeoutId = setTimeout(() => {
      getDoctorForSearch(value);
    }, 300);

    // Store the timeout ID
    setTimeoutId(newTimeoutId);
  };

  const getDoctorForSearch = async (value) => {
    try {
      setToDoctorSearchLoader(true);
      const fd = new FormData();
      fd.append("search", value);

      let response = await getDoctorForSearchApi(fd);
      if (response) {
        if (response.data.res === true) {
          if (response.data.doctors.length > 0) {
            setToDoctorSearchList(response.data.doctors);
          } else {
            setToDoctorSearchList([]);
          }
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
    } finally {
      setToDoctorSearchLoader(false);
    }
  };

  const handleSelectMessageSender = (type, selectedItem) => {
    let tempObj = { ...messageSenderObj };
    if (type === "to-doctor") {
      tempObj.type = type;
      selectedItem.id = selectedItem.user_id;
      tempObj.selectedItem = selectedItem;
    } else if (type === "to-patient") {
      tempObj.type = type;
      tempObj.selectedItem = {
        id: appointmentDetails?.patient_details[0]?.id,
        first_name: appointmentDetails?.patient_details[0]?.first_name,
        last_name: appointmentDetails?.patient_details[0]?.last_name,
      };
    } else if (type === "refer-to") {
      tempObj.type = type;
      if (!selectedItem) {
        tempObj.docNotAvailable = true;
        tempObj.selectedItem = {
          id: "",
          first_name: toDoctorSearchText,
          last_name: "",
        };
      } else {
        selectedItem.id = selectedItem.user_id;
        tempObj.selectedItem = selectedItem;
      }
    }
    setShowToDoctorModal(false);
    setShowReferDoctorModal(false);
    setMessageSenderObj(tempObj);
  };

  const getAppointmentMessage = async () => {
    try {
      const fd = new FormData();
      fd.append("appointment_id", appId);
      fd.append("type", "doctor");

      let response = await getAppointmentMessageApi(fd);
      if (response) {
        if (response.data.res === true) {
          if (response.data.data.length > 0) {
            const tempDoctorArray = [];
            const tempReferArray = [];
            setMessageList(response.data.data);
            response.data.data.forEach((message) => {
              if (message.types === "doctor") {
                if (!tempDoctorArray.includes(message.to)) {
                  tempDoctorArray.push(message.to);
                }
              }
              if (message.types === "refer") {
                if (!tempReferArray.includes(message.to)) {
                  tempReferArray.push(message.to);
                }
              }
            });
            setToDoctorAndReferList({
              doctorList: tempDoctorArray,
              referList: tempReferArray,
            });
          } else {
            setMessageList([]);
          }
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
    } finally {
    }
  };


  const handleReadMesssage = async (patientId) => {
    try {
      const fd = new FormData();
      fd.append("from_id", patientId);
      fd.append("read_type", "doctor");
      let response = await readDoctorMessageApi(fd);
      if (response) {
        if (response.data.res === true) {
          let tempAppDetails = { ...appointmentDetails };
          tempAppDetails.patient_read_count = 0;
          setAppointmentDetails(tempAppDetails);
        } else {
          toast.error(
            response.data.msg ||
            "Something went wrong in server. Please try again.",
            { autoClose: 1500 },
          );
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
    } finally {
    }
  };







  const getReferTemplate = async () => {
    try {
      const fd = new FormData();
      fd.append("type", "refer");
      let response = await getDoctorAllTemplateApi(fd);
      if (response) {
        if (response.data.res === true) {
          setReferTemplateList(response.data.data);
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
    } finally {
    }
  };



  // Dans ton composant ConsultationObservations, au niveau supérieur (avec les autres useState) :
  const [modalChartData, setModalChartData] = useState([]);
  const [modalChartLoading, setModalChartLoading] = useState(false);
  const [modalProtocolsoinsData, setModalProtocolsoinsData] = useState([]);
  const [modalProtocolsoinsLoading, setModalProtocolsoinsLoading] =
    useState(false);

  // Effet pour charger les données - Récupérer UNIQUEMENT pour cet appointment
  useEffect(() => {
    const loadChartData = async () => {
      // Utiliser l'appointment_id de l'observation sélectionnée, ou appId par défaut
      const appointmentId = selectedObservationItem?.appointment_id || appId;
      const patientId = appointmentDetails?.patient_details?.[0]?.id;
      const doctorId = userData?.users?.id;

      if (!appointmentId || !patientId || !doctorId) {
        console.debug(
          "[ModalChartData] Missing params - appointmentId:",
          appointmentId,
          "patientId:",
          patientId,
          "doctorId:",
          doctorId,
        );
        setModalChartData([]);
        return;
      }

      setModalChartLoading(true);
      try {
        let items = [];

        // Load only the points attached to the current appointment.
        try {
          console.log(
            "[ModalChartData] Chargement pour appointment:",
            appointmentId,
          );
          const chartRequests = await loadChartRequests();
          items = await chartRequests.loadAppointmentWeights(
            doctorId,
            patientId,
            appointmentId,
          );

          console.log(
            `[ModalChartData] ✓ ${items.length} points chargés pour appointment ${appointmentId}`,
          );
        } catch (err) {
          console.error("[ModalChartData] ✗ Erreur:", err?.message || err);
          items = [];
        }

        setModalChartData(items);
      } catch (error) {
        console.error("Error loading chart data:", error);
        setModalChartData([]);
      } finally {
        setModalChartLoading(false);
      }
    };

    if (showMedicalReport && (appId || selectedObservationItem?.appointment_id)) {
      loadChartData();
    }
  }, [showMedicalReport, appId, selectedObservationItem, appointmentDetails, userData]);

  // Effet pour charger les protocoles de soin
  useEffect(() => {
    const appointmentId = selectedObservationItem?.appointment_id;
    const patientId = appointmentDetails?.patient_details?.[0]?.id;
    const doctorId = userData?.users?.id;

    if (!appointmentId || !patientId || !doctorId) {
      setModalProtocolsoinsData([]);
      return;
    }

    const loadProtocolsoinsData = async () => {
      setModalProtocolsoinsLoading(true);
      try {
        const response =
          typeof listDoctorProtocolsoinss === "function"
            ? await listDoctorProtocolsoinss(doctorId, {
              patientId,
              appointmentId,
            })
            : await listDoctorProtocolsoins(doctorId, {
              patientId,
              appointmentId,
            });

        if (response.data.res === true) {
          setModalProtocolsoinsData(response.data.data || []);
        } else {
          setModalProtocolsoinsData([]);
        }
      } catch (error) {
        console.error("Error loading protocol soins data:", error);
        setModalProtocolsoinsData([]);
      } finally {
        setModalProtocolsoinsLoading(false);
      }
    };

    if (selectedObservationItem) {
      loadProtocolsoinsData();
    }
  }, [selectedObservationItem, appointmentDetails, userData]);

  // Call PrescriptionTab's internal delete function
  const handleTemplateDelete = async () => {
    if (prescriptionTabRef.current) {
      await prescriptionTabRef.current.handleTemplateDelete();
      setShowDeleteTempPopup(false);
    }
  };


  const handlePintReferTemplate = async () => {
    if (!selectedReferTemplate) {
      toast.warning("Please select a template by clicking on it.", {
        autoClose: 1500,
      });
      return;
    }
    try {
      setPopupBtnDis(true);
      let formData = new FormData();
      formData.append("appointment_id", appId || "");
      formData.append("template_id", selectedReferTemplate || "");
      formData.append("refer_message", referTemplateMessage || "");
      formData.append("message", referTextTemplateMessage || "");
      let response = await printReferDocumentTemplateApi(formData);
      if (response) {
        if (response.data.res === true) {
          if (response.data.data) {
            // Open PDF in new window - browser will handle print
            const printWindow = window.open(response.data.data, "_blank");
            if (printWindow) {
              printWindow.focus();
              // Note: User can use browser's print function (Ctrl+P) or the PDF viewer's print button
            } else {
              toast.warning("Please allow pop-ups to print the document.", {
                autoClose: 2000,
              });
            }
          }
        } else {
          toast.error(
            response.data.msg ||
            "Something went wrong in server. Please try again.",
            { autoClose: 1500 },
          );
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
    } finally {
      setPopupBtnDis(false);
    }
  };

  const handleTemplateTabChange = (item) => {
    setSelectedTemplateId(item?.id);
  };



  // handleEditorValuesChange - kept here because it's still used by ObservationsTab as prop
  const handleEditorValuesChange = async (
    newMedicalCondTitle,
    newExaminationContent,
    newOtherNotesContent,
    newReminderNotesContent,
  ) => {
    if (
      newMedicalCondTitle !== prevValues.medicalCondTitle ||
      newExaminationContent !== prevValues.examinationContent ||
      newOtherNotesContent !== prevValues.otherNotesContent ||
      newReminderNotesContent !== prevValues.reminderNotesContent
    ) {
      try {
        let formData = new FormData();
        formData.append("appointment_id", appId);
        formData.append("medical_condition_title", newMedicalCondTitle || "");
        formData.append("examination", newExaminationContent);
        formData.append("other_notes", newOtherNotesContent);
        formData.append("reminder_note", newReminderNotesContent);
        formData.append("is_periodic_visit", isPeriodicVisit ? 1 : 0);
        let response = await addObservationApi(formData);
        if (response) {
          if (response.data.res === true) {
            setPrevValues({
              medicalCondTitle: newMedicalCondTitle,
              examinationContent: newExaminationContent,
              otherNotesContent: newOtherNotesContent,
              reminderNotesContent: newReminderNotesContent,
            });
          } else {
            toast.error(
              response.data.msg ||
              "Something went wrong in server. Please try again.",
              { autoClose: 1500 },
            );
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {
          autoClose: 1500,
        });
      } finally {
        setScreenLoading(false);
      }
    }
  };

  const handleOpenReferPopup = async (referMessage, referTextMessage) => {
    if (referTemplateList?.length === 0) {
      toast.warning(
        "Please add a refer template from prescription management page.",
        { autoClose: 2500 },
      );
    } else {
      setReferTemplateMessage(referMessage);
      setReferTextTemplateMessage(referTextMessage);
      setShowReferTemplateModal(true);
    }
  };

  const handleAddKid = async () => {
    if (!addPatientObject?.gender) {
      toast.warning("Please select gender.", { autoClose: 1500 });
    } else if (!addPatientObject?.firstName) {
      toast.warning("Please enter first name.", { autoClose: 1500 });
    } else if (/[\u0600-\u06FF]/.test(addPatientObject?.firstName)) {
      toast.warning("First name cannot contain Arabic characters.", {
        autoClose: 1500,
      });
    } else if (!addPatientObject?.lastName) {
      toast.warning("Please enter last name.", { autoClose: 1500 });
    } else if (/[\u0600-\u06FF]/.test(addPatientObject?.lastName)) {
      toast.warning("Last name cannot contain Arabic characters.", {
        autoClose: 1500,
      });
    } else if (!addPatientObject?.month) {
      toast.warning("Please select month.", { autoClose: 1500 });
    } else if (!addPatientObject?.day) {
      toast.warning("Please select day.", { autoClose: 1500 });
    } else if (!addPatientObject?.year) {
      toast.warning("Please select year.", { autoClose: 1500 });
    } else if (!addPatientObject?.birthCity) {
      toast.warning("Please select birth wilaya.", { autoClose: 1500 });
    } else if (!addPatientObject?.birthCommune) {
      toast.warning("Please select birth commune.", { autoClose: 1500 });
    } else if (!addPatientObject?.relation) {
      toast.warning("Please select relation.", { autoClose: 1500 });
    } else {
      setPopupBtnDis(true);
      try {
        let formData = new FormData();
        formData.append("gender", addPatientObject.gender);
        formData.append("first_name", addPatientObject.firstName);
        formData.append("last_name", addPatientObject.lastName);
        formData.append("relation", addPatientObject.relation);
        formData.append("month", addPatientObject.month);
        formData.append("day", addPatientObject.day);
        formData.append("year", addPatientObject.year);
        formData.append("wilaya_id", addPatientObject.birthCity);
        formData.append("commune_id", addPatientObject.birthCommune);
        formData.append("parent_id", appointmentDetails?.patient_details[0].id);

        let response = await doctorAddPatientMemberApi(formData);
        if (response) {
          if (response.data.res === true) {
            setShowProfileModal(false);
            setAddPatientObject({});
            getAppointmentDetails();
            toast.success(
              response.data.msg ? response.data.msg : "Added successfully.",
              { autoClose: 1500 },
            );
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
        setPopupBtnDis(false);
      } catch (error) {
        setPopupBtnDis(false);
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {
          autoClose: 1500,
        });
      }
    }
  };

  const handleChangePhoneNumber = async () => {
    if (!newPhoneNumber) {
      toast.warning("Please enter new phone number.", { autoClose: 1500 });
    } else if (newPhoneNumber && !/^\d{5,10}$/.test(newPhoneNumber)) {
      toast.warning("New phone number is not valid.", { autoClose: 1500 });
    } else {
      setPopupBtnDis(true);
      try {
        let formData = new FormData();
        formData.append("cell_phone", newPhoneNumber);
        formData.append(
          "patient_id",
          appointmentDetails?.patient_details[0].id,
        );

        let response = await doctorEditPhoneNumberApi(formData);
        if (response) {
          if (response.data.res === true) {
            setShowChangePhoneModal(false);
            setNewPhoneNumber("");
            getAppointmentDetails();
            toast.success(
              response.data.msg
                ? response.data.msg
                : "Number edited successfully.",
              { autoClose: 1500 },
            );
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
        setPopupBtnDis(false);
      } catch (error) {
        setPopupBtnDis(false);
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {
          autoClose: 1500,
        });
      }
    }
  };

  const handleSelectKid = async () => {
    if (!appId || !selectedKidDetails?.id || !appointmentDetails?.patient_id) {
      toast.warning("Something went wrong.", { autoClose: 1500 });
    } else {
      setPopupBtnDis(true);
      try {
        let formData = new FormData();
        formData.append("appointment_id", appId);
        formData.append("patient_id", selectedKidDetails?.id);
        formData.append("parent_patient_id", appointmentDetails?.patient_id);

        let response = await choseChildApi(formData);
        if (response) {
          if (response.data.res === true) {
            setChoosePatientConfirmPopup(false);
            setSelectedKidDetails(null);
            getAppointmentDetails();
            toast.success(
              response.data.msg ? response.data.msg : "Updated successfully.",
              { autoClose: 1500 },
            );
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
      } catch (error) {
        console.error(error);
        toast.error("Something went wrong in server. Please try again.", {
          autoClose: 1500,
        });
      } finally {
        setPopupBtnDis(false);
      }
    }
  };

  const handleStatusChange = async (value) => {
    if (value === "absent") {
      setAbsensePopupOpen(true);
      dispatch(setAbsenceModalOpen(true));
    }
  };

  const markAbsentSubmit = async () => {
    setModalBtnDis(true);
    try {
      const fd = new FormData();
      fd.append(`ids[0][id]`, appId);
      fd.append(`reason`, absenseReason);
      let response = await absenceAppointmentApi(fd);
      if (response) {
        if (response.data.res === true) {
          getAppointmentDetails();
          toast.success(
            response.data.msg
              ? response.data.msg
              : "Absence reasons updated successfully.",
            { autoClose: 1500 },
          );
          setAbsensePopupOpen(false);
          dispatch(setAbsenceModalOpen(false));
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
    } finally {
      setModalBtnDis(false);
    }
  };
  useEffect(() => {
    if (activeTab === "cobot") {
      sendWakeupIfNeeded();
    }
  }, [activeTab, sendWakeupIfNeeded]);
  const handleAppIsFinished = async () => {
    try {
      setDeleteBtnDis(true);
      const fd = new FormData();
      fd.append("id", appId);
      fd.append("type", "finish");
      fd.append("value", "2");
      let response = await updatePriorityApi(fd);
      if (response) {
        if (response.data.res === true) {
          getAppointmentDetails();
          // Finishing detaches the patient from the waiting room server-side —
          // refresh it immediately here (real-time listeners handle other views).
          queryClient.invalidateQueries({ queryKey: queryKeys.waitingRoom.all });
          setShowDeletePopup(false);
          toast.success(
            response.data.msg ? response.data.msg : "Updated successfully.",
            { autoClose: 1500 },
          );
        } else {
          toast.error(response.data.msg, { autoClose: 1500 });
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
    } finally {
      setDeleteBtnDis(false);
    }
  };

  // Load only critical appointment details on mount
  useEffect(() => {
    getAppointmentDetails();
  }, [appId]);

  // Auto-open reminders modal on page load if reminders exist
  useEffect(() => {
    const reminderShown = appId
      ? localStorage.getItem(`reminderShown_${appId}`) || localStorage.getItem(`dontShowReminders_${appId}`)
      : null;
    if (
      !reminderShown &&
      hasVisibleReminderText(allAppDetails?.previousObservations?.reminder_note)
    ) {
      localStorage.setItem(`reminderShown_${appId}`, "true");
      setShowRemindersModal(true);
    }
  }, [allAppDetails, appId, hasVisibleReminderText]);

  // Load message tab data only when message tab is active
  useEffect(() => {
    if (activeTab === "message") {
      getAppointmentMessage();
      getReferTemplate();
    }
  }, [appId, activeTab]);


  useEffect(() => {
    // Scroll to the bottom of the chat list
    if (chatListRef.current) {
      chatListRef.current.scrollTop = chatListRef.current.scrollHeight;
    }
  }, [activeTab, messageList]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showOtherTemplateDropdown &&
        !event.target.closest(".OtherTempleteBtn")
      ) {
        setShowOtherTemplateDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showOtherTemplateDropdown]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isProfileDropdownOpen && !event.target.closest(".profile-menu")) {
        setIsProfileDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isProfileDropdownOpen]);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop } = chatListRef.current;

      // Check if the user is scrolling up
      if (scrollTop < lastScrollTop) {
        // Check if the scroll position is near the top (within 100 pixels)
        if (scrollTop <= 100 && !alertShown) {
          // alert("You have reached the top of the chat list!");
          setAlertShown(true); // Set flag to true to prevent further alerts
        }
      } else {
        // Reset alert flag when scrolling down
        setAlertShown(false);
      }

      // Update the last scroll position
      setLastScrollTop(scrollTop);
    };

    const chatList = chatListRef.current;
    if (chatList) {
      chatList.addEventListener("scroll", handleScroll);
    }

    // Clean up the event listener on component unmount
    return () => {
      if (chatList) {
        chatList.removeEventListener("scroll", handleScroll);
      }
    };
  }, [lastScrollTop, activeTab, messageList]);

  // Load availability when profile details and calendar value are ready
  useEffect(() => {
    const docId = profileDetails?.id || allDetails?.id;
    if (docId && calendarValue) {
      getDateAvailabilityList(
        docId,
        format(calendarValue, "yyyy-MM-dd"),
        "For online consultation",
      );
    }
  }, [profileDetails?.id, calendarValue]);



  // protocole de soin
  const [careSteps, setCareSteps] = React.useState([]);

  // Modale d’ajout
  const [showTimelineModal, setShowTimelineModal] = React.useState(false);



  // normalise une clé texte
  // ========= DOCS: IDs & state =========
  // on récupère les IDs depuis tes sources existantes
  const DOC_doctorId =
    userData?.users?.id || userData?.user?.id || userData?.doctor?.id || null;

  const DOC_patientId =
    appointmentDetails?.patient_details?.[0]?.id ||
    allAppDetails?.data?.[0]?.patient_details?.[0]?.id ||
    null;

  const DOC_appointmentId = appId || null;

  // ---------- Utils IDs (derived) ----------
  const toInt = (v) => {
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : null;
  };
  const doctorId = toInt(DOC_doctorId);
  const patientId = toInt(DOC_patientId);

  // readOnly tu l'as déjà calculé plus haut
  // Charger les points de charts
  useEffect(() => {
    const loadChartPoints = async () => {
      try {
        if (DOC_doctorId && DOC_patientId) {
          const chartRequests = await loadChartRequests();
          const points = await chartRequests.loadPatientPoints(
            DOC_doctorId,
            DOC_patientId,
            appId,
          );
          setChartPoints(points);
        }
      } catch (err) {
        console.error("Erreur lors du chargement des points de charts:", err);
      }
    };

    loadChartPoints();
  }, [DOC_doctorId, DOC_patientId, appId]);

  const [tlForm, setTlForm] = useState({
    year: new Date().getFullYear().toString(),
    date: "",
    title: "",
    description: "",
    client: "",
  });

  // state + refs
  // state + refs
  const [diagTitles, setDiagTitles] = useState([]); // ex: ["Diabète", "Anémie", ...]
  const [showDiagPanel, setShowDiagPanel] = useState(false);
  const diagInputRef = useRef(null);
  const diagPanelRef = useRef(null);

  // charge depuis l’API /doctor/{id}/config/diagnostics (nouveau) + fallback ancien
  // charge depuis /doctor/{id}/config/diagnostics (nouveau) + fallback ancien
  const fetchDiagTitles = async (force = false) => {
    console.debug("[Diag] fetchDiagTitles called", {
      readOnly,
      diagLoaded,
      force,
      DOC_doctorId,
    });

    // évite les recharges inutiles (sauf si force === true)
    if (diagLoaded && !force) {
      console.debug("[Diag] skip: already loaded");
      return;
    }

    const norm = (s) =>
      String(s || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();

    // util: extraire un tableau depuis plusieurs formes de payload
    const extractArray = (resp) => {
      const root = resp?.data ?? resp;
      const candidates = [
        root?.data,
        root?.diagnostics,
        root?.items,
        root?.rows,
        Array.isArray(root) ? root : null,
      ].filter(Boolean);

      for (const arr of candidates) {
        if (Array.isArray(arr)) return arr;
      }
      return [];
    };

    // util: mapper string/objet -> string titre
    const mapToTitle = (d) =>
      String(
        typeof d === "string"
          ? d
          : (d?.item ??
            d?.title ??
            d?.diagnostic ??
            d?.name ??
            d?.titre ??
            d?.label ??
            d?.nom ??
            d?.parametre ??
            ""),
      ).trim();

    const all = [];
    try {
      // 1) NOUVEL API prioritaire (on tente même si DOC_doctorId vaut 0)
      if (DOC_doctorId !== undefined && DOC_doctorId !== null) {
        try {
          console.debug("[Diag] calling listDiagnosticsApi", { DOC_doctorId });
          const respNew = await listDiagnosticsApi(DOC_doctorId);
          const arrNew = extractArray(respNew).map(mapToTitle).filter(Boolean);
          console.debug("[Diag] listDiagnosticsApi -> count", arrNew.length);
          all.push(...arrNew);
        } catch (e) {
          console.warn(
            "[Diag] listDiagnosticsApi error:",
            e?.response?.data || e,
          );
        }
      } else {
        console.warn("[Diag] DOC_doctorId is missing/invalid:", DOC_doctorId);
      }

      // 2) ANCIEN API (merge/fallback)
      try {
        console.debug("[Diag] calling getDiagnosticTitlesApi (fallback/merge)");
        const respOld = await getDiagnosticTitlesApi();
        const arrOld = extractArray(respOld)
          .map((x) =>
            typeof x === "string" ? x : (x?.titre ?? x?.title ?? x?.name),
          )
          .filter(Boolean);
        console.debug("[Diag] getDiagnosticTitlesApi -> count", arrOld.length);
        all.push(...arrOld);
      } catch (e) {
        console.warn(
          "[Diag] getDiagnosticTitlesApi error:",
          e?.response?.data || e,
        );
      }

      // déduplication (accents/casse)
      const seen = new Set();
      const unique = [];
      for (const t of all) {
        const k = norm(t);
        if (k && !seen.has(k)) {
          seen.add(k);
          unique.push(t);
        }
      }

      console.debug("[Diag] unique final count", unique.length);
      setDiagTitles(unique);
    } catch (e) {
      console.error("[Diag] fetch error", e);
    } finally {
      setDiagLoaded(true);
      console.debug("[Diag] fetchDiagTitles done");
    }
  };


  // mise en forme avec surlignage simple

  // sélectionner un titre
  const chooseDiagTitle = (t) => {
    setMedicalCondTitle(t);
    setShowDiagPanel(false);
    setPrevValues((prev) => ({ ...prev, medicalCondTitle: t }));
    handleEditorValuesChange(
      t,
      examinationContent,
      otherNotesContent,
      reminderNotesContent,
    );
  };

  // Assure-toi d'avoir importé :
  /*
  import React, { useState, useRef, useEffect, useMemo } from "react";
  */

  const editorWrapRef = useRef(null);
  const panelRef = useRef(null);

  // --- toggle autofill (activé par défaut) ---

  // --- états autofill ---
  const [examQuick, setExamQuick] = useState("");
  const [panelSuggestions, setPanelSuggestions] = useState([]); // [{id,categorie,item}]
  const [showPanel, setShowPanel] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);


  // --- fetch suggestions (debounced) ---
  const doFetch = useMemo(
    () =>
      debounce(async (q) => {
        try {
          if (!autofillEnabled || !q?.trim()) {
            setPanelSuggestions([]);
            setActiveIndex(-1);
            setShowPanel(false);
            return;
          }

          // GET /api/doctor/observs?q=...
          const res = await axios.get(`${API_BASE_URL}doctor/observs`, {
            params: { q },
          });
          const arr = res?.data?.data ?? [];
          setPanelSuggestions(arr);
          setActiveIndex(arr.length ? 0 : -1);
          setShowPanel(arr.length > 0 && !readOnly);
        } catch (e) {
          console.error("Fetch observ suggestions failed:", e);
          setPanelSuggestions([]);
          setActiveIndex(-1);
          setShowPanel(false);
        }
      }, 300),
    [autofillEnabled, readOnly],
  );


  // --- click hors du panneau/éditeur => fermer ---
  useEffect(() => {
    const onDocClick = (e) => {
      const inPanel = panelRef.current?.contains(e.target);
      const inEditor = editorWrapRef.current?.contains(e.target);
      if (!inPanel && !inEditor) {
        setShowPanel(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  // --- navigation clavier quand le panneau est ouvert (↑/↓/Enter/Esc) ---
  useEffect(() => {
    if (!showPanel || !panelSuggestions.length || readOnly) return;

    const onKey = (e) => {
      if (["ArrowDown", "ArrowUp", "Enter", "Escape"].includes(e.key)) {
        // On empêche le comportement par défaut dans l’éditeur (déplacement/retour ligne)
        e.preventDefault();
        e.stopPropagation();
      }
      if (e.key === "ArrowDown") {
        setActiveIndex((i) => (i + 1) % panelSuggestions.length);
      } else if (e.key === "ArrowUp") {
        setActiveIndex(
          (i) => (i - 1 + panelSuggestions.length) % panelSuggestions.length,
        );
      } else if (e.key === "Enter") {
        const it = panelSuggestions[activeIndex];
        if (it) insertExamItem(it);
      } else if (e.key === "Escape") {
        setShowPanel(false);
      }
    };

    document.addEventListener("keydown", onKey, true);
    return () => document.removeEventListener("keydown", onKey, true);
  }, [showPanel, panelSuggestions, activeIndex, readOnly]);

  // --- cacher le panneau si on désactive l’autofill ---
  useEffect(() => {
    if (!autofillEnabled) {
      setPanelSuggestions([]);
      setShowPanel(false);
    } else if (examQuick.trim()) {
      doFetch(examQuick);
    }
  }, [autofillEnabled]);

  // --- POSITIONNEMENT PANEL ---
  const [panelPos, setPanelPos] = useState({ left: 8, top: 0, width: 280 }); // top sera calculé


  // --- STATES & REFS ---

  // Doctor examinations data loaded via TanStack Query (24h persistent cache)
  const { data: allExams = [], isLoading: loadingExams } = useDoctorExaminations(
    profileDetails?.id || appointmentDetails?.doctor_id
  );

  const autofillEnabledRef = useRef(autofillEnabled); // ✅ FIX: define it
  const readOnlyRef = useRef(readOnly);
  const allExamsRef = useRef(allExams);

  // refs "snapshot" pour éviter de mettre ces états dans joditConfig deps
  const showPanelRef = useRef(showPanel);
  const panelSuggestionsRef = useRef(panelSuggestions);
  const activeIndexRef = useRef(activeIndex);

  // sync refs directly
  showPanelRef.current = showPanel;
  panelSuggestionsRef.current = panelSuggestions;
  activeIndexRef.current = activeIndex;
  autofillEnabledRef.current = autofillEnabled;
  readOnlyRef.current = readOnly;
  allExamsRef.current = allExams;

  // --- OUTSIDE CLICK TO CLOSE PANEL ---
  useEffect(() => {
    function onDocClick(e) {
      if (!panelRef.current) return;
      if (!panelRef.current.contains(e.target)) setShowPanel(false);
    }
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);



  // Normalize empty HTML content (remove <p><br></p> etc.)
  const normalizeEmptyHtml = (html) => {
    if (!html) return "";
    const temp = html
      .replace(/&nbsp;/gi, " ")
      .replace(/<br\s*\/?>/gi, "")
      .replace(/<[^>]+>/g, "")
      .trim();
    return temp.length === 0 ? "" : html;
  };




  // petite sécurité si tes items peuvent contenir des caractères HTML
  const escapeHTML = (s = "") =>
    s.replace(
      /[&<>"']/g,
      (m) =>
        ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;",
        })[m],
    );
  function isEditorEmpty(j) {
    try {
      const html = String(j?.value ?? "");
      const plain = html
        .replace(/&nbsp;/gi, " ")
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<[^>]+>/g, "")
        .trim();
      return plain.length === 0;
    } catch {
      return true;
    }
  }

  // Un vrai saut de ligne (fiable) et caret placé après
  function insertHardBR(j) {
    try {
      j.execCommand?.("insertLineBreak");
      return;
    } catch { }
    try {
      const doc = j?.editorDocument || document;
      const br = doc.createElement("br");
      j.selection?.insertNode?.(br);
      const r = doc.createRange();
      r.setStartAfter(br);
      r.collapse(true);
      j.selection?.selectRange?.(r);
    } catch { }
  }

  const insertExamItem = useCallback((it) => {
    const onInserted =
      typeof it?.onInserted === "function" ? it.onInserted : null;
    try {
      const j = editor.current?.editor;
      ignoreUntilUserTypesRef.current = true;
      const text = escapeHTML(it.item || "");
      // `block`: insert as a plain paragraph (no "- " bullet prefix).
      // `leadingBreaks`: extra blank lines to leave before the inserted text.
      const prefix = it.block ? "" : "- ";
      const leadingBreaks = Math.max(0, Number(it.leadingBreaks) || 0);

      if (j && j.selection) {
        j.selection.focus();

        // Move onto a fresh line, then leave `leadingBreaks` blank lines before
        // the value (1 for a suggestion, 2 for the transcript), then the value.
        // Bare <br> inside inserted content survives Jodit's cleanHTML; empty
        // <p>/<div> blocks render zero-height (or get their &nbsp; replaced by a
        // collapsing space), so they can't be used as spacers.
        const breaks = isEditorEmpty(j) ? 0 : Math.max(0, leadingBreaks) + 1;
        j.selection.insertHTML(`${"<br>".repeat(breaks)}${prefix}${text}&nbsp;`);

        requestAnimationFrame(() => {
          const value = j.value || "";
          setExaminationContent(value);
          // Guard against persisting an empty editor (Jodit hiccup) — we just
          // inserted, so a blank value here means the insert didn't land.
          if (value.trim()) onInserted?.(value);
          Promise.resolve().then(() => {
            ignoreUntilUserTypesRef.current = false;
          });
        });
      } else {
        // No live editor selection (e.g. the examination tab was opened but the
        // editor never got focus) — append to the mirrored state value as HTML,
        // same break rules as the editor path.
        const prev = examinationContentRef.current || "";
        const breaks = prev ? Math.max(0, leadingBreaks) + 1 : 0;
        const value = `${prev}${"<br>".repeat(breaks)}${prefix}${text}&nbsp;`;
        setExaminationContent(value);
        ignoreUntilUserTypesRef.current = false;
        onInserted?.(value);
      }

      setShowPanel(false);
      setActiveIndex(0);
      setPanelSuggestions([]);
      setExamQuick("");
      try {
        j?.selection?.focus?.();
      } catch { }
    } catch (e) {
      console.error("[EXAMS] insert failed:", e);
      ignoreUntilUserTypesRef.current = false;
    }
  }, []);

  function useJoditConfig({ readOnly, insertExamItem, placeholderText }) {
    return useMemo(
      () => ({
        ...createObservationEditorConfig({ readOnly, placeholderText }),

        events: {
          keydown(e) {
            try {
              if (
                (e.key === "-" || e.key === "*") &&
                isAtLineStart(window.getSelection?.())
              ) {
                e.stopImmediatePropagation?.();
              }
            } catch { }

            if (!readOnly && e.key === "Enter") {
              const list = panelSuggestionsRef.current || [];
              const selectingFromPanel =
                showPanelRef.current && list.length > 0;
              if (selectingFromPanel) {
                e.preventDefault();
                const max = list.length - 1;
                const idx = Math.min(
                  Math.max(activeIndexRef.current ?? 0, 0),
                  max,
                );
                const it = list[idx];
                if (it) insertExamItem(it);
                return;
              }
            }

            if (ignoreUntilUserTypesRef.current) return;
            const list = panelSuggestionsRef.current || [];
            const show = showPanelRef.current;
            if (!show || list.length === 0) return;

            const max = list.length - 1;
            if (e.key === "ArrowDown") {
              e.preventDefault();
              setActiveIndex((i) => (i >= max ? 0 : i + 1));
            } else if (e.key === "ArrowUp") {
              e.preventDefault();
              setActiveIndex((i) => (i <= 0 ? max : i - 1));
            } else if (e.key === "Escape") {
              e.preventDefault();
              setShowPanel(false);
              try {
                this?.selection?.focus?.();
              } catch { }
            }
          },
          keyup(e) {
            /* ton code existant */
          },
          afterInsertNode() {
            stripAllLists?.();
          },
          afterPaste() {
            stripAllLists?.();
          },
          blur(editor) {
            // ✅ Save content only on blur to prevent cursor jumping
            if (editor && editor.value !== undefined) {
              console.log("Editor blur - content saved");
            }
          },
        },
      }),
      [insertExamItem, placeholderText, readOnly],
    );
  }
  const joditConfigExamination = useJoditConfig({
    readOnly: false, // ✅ Explicitly allow editing
    insertExamItem,
    placeholderText: "Examination",
  });
  const joditConfigOtherNotes = useJoditConfig({
    readOnly: false, // ✅ Explicitly allow editing
    insertExamItem,
    placeholderText: "Other notes", // ou "Autres notes"
  });
  const joditConfigReminderNotes = useJoditConfig({
    readOnly: false,
    insertExamItem,
    placeholderText: "Reminder notes",
  }); // ✅ Explicitly allow editing

  // --- QUICK BAR (champ en bas) ---
  const [quickValue, setQuickValue] = useState("");
  const [quickSuggestions, setQuickSuggestions] = useState([]);
  const [quickActive, setQuickActive] = useState(0);

  // filtre côté QuickBar
  const recomputeQuick = useCallback((v) => {
    const s = (v || "").trim().toLowerCase();
    if (!s) {
      setQuickSuggestions([]);
      setQuickActive(0);
      return;
    }
    const sug = (allExamsRef.current || [])
      .filter(
        (x) =>
          (x.item || "").toLowerCase().includes(s) ||
          (x.categorie || "").toLowerCase().includes(s),
      )
      .slice(0, 30);
    setQuickSuggestions(sug);
    setQuickActive(0);
  }, []);

  const clearQuick = useCallback(() => {
    setQuickValue("");
    setQuickSuggestions([]);
    setQuickActive(0);
  }, []);

  // mémorise si le scroller a déjà été "plein" au moins une fois
  const becameFullOnceRef = useRef(false);

  // calcule une hauteur de ligne robuste depuis la zone éditable Jodit
  const getLineHeightPx = (root) => {
    if (!root) return 20;
    const wys = root.querySelector?.(".jodit-wysiwyg") || root;
    const cs = window.getComputedStyle(wys);
    const lh = parseFloat(cs.lineHeight);
    const fs = parseFloat(cs.fontSize);
    return Number.isFinite(lh) && lh > 0
      ? Math.round(lh)
      : Math.round((fs || 14) * 1.4);
  };

  // le scroller est-il "plein" (le contenu dépasse) ?
  const isFull = (node, eps = 1) => {
    if (!node) return false;
    return node.scrollHeight - node.clientHeight > eps;
  };

  // anime un petit scroll d’UNE ligne
  const scrollOneLine = (node, px) => {
    if (!node) return;
    const step = Math.max(1, px ?? getLineHeightPx(node));
    const start = node.scrollTop;
    const end = Math.min(node.scrollHeight - node.clientHeight, start + step);

    const duration = 120; // ms
    let t0;
    const tick = (t) => {
      if (!t0) t0 = t;
      const p = Math.min(1, (t - t0) / duration);
      node.scrollTop = start + (end - start) * p;
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  const selectQuick = useCallback((it) => {
    const j = editor.current?.editor;
    const scroller = contentScrollRef.current;
    const text = escapeHTML(it.item || "");

    // état "plein" avant insertion
    const wasFull = isFull(scroller);

    if (j?.s) {
      try {
        // surtout pas de j.selection.focus()
        if (!isEditorEmpty?.(j)) j.s.insertHTML("<br>");
        j.s.insertHTML(`- ${text}&nbsp;`);
        j.s.insertHTML("<br>");

        // attendre le reflow → maj state → décider du scroll
        requestAnimationFrame(() => {
          setExaminationContent(j.value || "");

          // un frame de plus pour que scrollHeight soit exact
          requestAnimationFrame(() => {
            const nowFull = isFull(scroller);

            if (nowFull) {
              if (becameFullOnceRef.current) {
                // déjà plein auparavant → on scrolle d’une seule ligne
                scrollOneLine(scroller);
              } else {
                // c’est la 1ère fois que ça devient plein → on ne scrolle pas
                becameFullOnceRef.current = true;
              }
            }
          });
        });
      } catch (e) {
        console.error("insert failed", e);
      }
    } else {
      // fallback sans instance Jodit
      setExaminationContent((prev) => {
        const empty = !String(prev || "")
          .replace(/<[^>]+>/g, "")
          .trim();
        return `${prev || ""}${empty ? "" : ""}- ${it.item}&nbsp;<br>`;
      });

      requestAnimationFrame(() => {
        const nowFull = isFull(scroller);
        if (nowFull) {
          if (becameFullOnceRef.current) scrollOneLine(scroller);
          else becameFullOnceRef.current = true;
        }
      });
    }

    // UI cleanup
    setQuickValue("");
    setQuickSuggestions([]);
    setQuickActive(0);
  }, []);

  function isAtLineStart(sel) {
    try {
      if (!sel || !sel.rangeCount) return false;
      const r = sel.getRangeAt(0).cloneRange();
      r.setStart(r.startContainer, 0);
      const before = r.toString();
      return !before || /^\s*$/.test(before);
    } catch {
      return false;
    }
  }

  function stripAllLists(root) {
    try {
      const r = root || document;
      // Only target lists inside Jodit editor, not the entire document (fixes sidebar CSS breaking)
      const lists = r.querySelectorAll?.(
        ".jodit-wysiwyg ul, .jodit-wysiwyg ol",
      );
      lists?.forEach((list) => {
        const parent = list.parentNode;
        if (!parent) return;
        const fr = document.createDocumentFragment();
        const items = list.querySelectorAll("li");
        items.forEach((li, idx) => {
          const span = document.createElement("span");
          span.innerHTML = li.innerHTML; // conserve formatage inline
          fr.appendChild(span);
          if (idx < items.length - 1)
            fr.appendChild(document.createElement("br"));
        });
        parent.replaceChild(fr, list);
      });
    } catch { }
  }


  const onQuickChange = useCallback(
    (e) => {
      const v = e.target.value;
      setQuickValue(v);
      recomputeQuick(v);
    },
    [recomputeQuick],
  );

  // Bouton "+" → insérer le texte أو la première suggestion, en commençant par "- "
  const onQuickSubmit = useCallback(() => {
    const v = (quickValue || "").trim();
    console.log("🔵 onQuickSubmit called, value:", v);
    if (!v) {
      console.log("⚠️ Empty value, returning");
      return;
    }

    // 1) S'il y a des suggestions → insérer la première
    if (quickSuggestions?.length) {
      console.log("✅ Has suggestions, calling selectQuick");
      selectQuick(quickSuggestions[0]);
      return;
    }

    // 2) Sinon → insérer le texte directement avec espace seulement
    console.log("📝 No suggestions, inserting text directly");
    try {
      const j = editor.current?.editor;
      console.log("Editor instance:", j ? "✅ Found" : "❌ Not found");
      if (j) {
        try {
          j.selection?.focus?.();

          // Remove trailing <br> tags before inserting new text
          const wysiwyg = j.editor;
          if (wysiwyg) {
            // Find and remove trailing <br> elements
            const children = Array.from(wysiwyg.childNodes);
            for (let i = children.length - 1; i >= 0; i--) {
              const node = children[i];
              if (node.nodeName === "BR") {
                node.remove();
              } else if (node.nodeType === 3 && !node.textContent.trim()) {
                // Remove empty text nodes
                continue;
              } else {
                break; // Stop when we hit actual content
              }
            }
          }

          // Move cursor to end
          const sel = j.editorWindow?.getSelection?.();
          const range = j.editorDocument.createRange();
          range.selectNodeContents(j.editor);
          range.collapse(false);
          sel?.removeAllRanges?.();
          sel?.addRange?.(range);
        } catch (e) {
          console.log("⚠️ Cursor positioning failed:", e);
        }

        // Don't add line break - just add space if content exists
        const safe = v
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");
        const needsSpace = !isEditorEmpty(j);
        console.log("Inserting plain text:", safe, "needsSpace:", needsSpace);
        try {
          // Insert plain text with space if needed, no line breaks
          const textToInsert = `${needsSpace ? " " : ""}${safe}`;
          j.selection.insertHTML(textToInsert);
          console.log("✅ insertHTML succeeded");
        } catch (e) {
          console.log("⚠️ insertHTML failed, trying execCommand");
          try {
            const textToInsert = `${needsSpace ? " " : ""}${safe}`;
            j.execCommand && j.execCommand("insertHTML", false, textToInsert);
            console.log("✅ execCommand succeeded");
          } catch { }
        }
        requestAnimationFrame(() => {
          const newContent = j.value || "";
          console.log(
            "Setting examination content, length:",
            newContent.length,
          );
          setExaminationContent(newContent);
          try {
            j.selection?.focus?.();
            const r = j.selection?.range;
            if (r) {
              r.collapse(false);
              j.selection.selectRange(r);
            }
          } catch { }
        });
      } else {
        console.log("Using fallback setState");
        setExaminationContent((prev) => {
          const prevStr = String(prev || "").replace(/<br\s*\/?>\s*$/gi, ""); // Remove trailing <br>
          // Append with a space if previous content doesn't end with whitespace
          const spacer = /\s$/.test(prevStr) || prevStr.length === 0 ? "" : " ";
          const result = prevStr + spacer + v;
          console.log("Fallback result length:", result.length);
          return result;
        });
      }
    } catch (err) {
      console.error("❌ Insert failed:", err);
    }
    console.log("Calling clearQuick");
    clearQuick();
  }, [quickValue, quickSuggestions, selectQuick, clearQuick]);

  const onQuickKeyDown = useCallback(
    (e) => {
      console.log("⌨️ Key pressed:", e.key);
      const max = quickSuggestions.length - 1;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setQuickActive((i) => (i >= max ? 0 : i + 1));
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setQuickActive((i) => (i <= 0 ? max : i - 1));
      } else if (e.key === "Enter") {
        console.log(
          "🔑 Enter pressed, suggestions count:",
          quickSuggestions.length,
        );
        e.preventDefault();

        if (quickSuggestions.length > 0) {
          const it = quickSuggestions[Math.min(Math.max(quickActive, 0), max)];
          if (it) {
            console.log("Selecting suggestion:", it.item);
            selectQuick(it);
          }
        } else {
          console.log("No suggestions, calling onQuickSubmit");
          onQuickSubmit();
        }
      } else if (e.key === "Escape") {
        clearQuick();
      }
    },
    [quickSuggestions, quickActive, selectQuick, clearQuick, onQuickSubmit],
  );

  const quickBarRef = useRef(null);
  const contentScrollRef = useRef(null);
  const [quickListRect, setQuickListRect] = useState(null);

  useLayoutEffect(() => {
    const bar = quickBarRef.current;
    const scroller = contentScrollRef.current;
    if (!bar || !scroller) return;

    const place = () => {
      if (!quickSuggestions.length) {
        setQuickListRect(null);
        return;
      }
      const r = bar.getBoundingClientRect();

      // espace dispo sous la barre dans la fenêtre
      const spaceBelow = Math.max(100, window.innerHeight - r.bottom - 12);

      setQuickListRect({
        top: r.bottom + 6,
        left: r.left,
        width: r.width,
        maxHeight: Math.min(260, spaceBelow),
      });
    };

    // Réserver l’espace sous le contenu (padding-bottom)
    const ro = new ResizeObserver(() => {
      const h = Math.ceil(bar.getBoundingClientRect().height);
      scroller.style.setProperty("--qb-h", `${h}px`);
      place();
    });
    ro.observe(bar);

    place();

    const onScroll = () => requestAnimationFrame(place);
    scroller.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", place);
    window.addEventListener("scroll", place, true); // si d’autres scroll-containers existent

    return () => {
      ro.disconnect();
      scroller.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", place);
      window.removeEventListener("scroll", place, true);
    };
  }, [quickSuggestions.length, quickValue]);

  // ========================
  // Protocol de soin — LOGIC
  // ========================

  // --- Couleurs ---
  const textColorOn = (hex) => {
    if (!hex || typeof hex !== "string") return undefined;
    const c = hex.replace("#", "");
    if (c.length !== 6) return undefined;
    const r = parseInt(c.slice(0, 2), 16),
      g = parseInt(c.slice(2, 4), 16),
      b = parseInt(c.slice(4, 6), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 160 ? "#111" : "#fff";
  };

  const withAlpha = (input, alpha = 0.14) => {
    if (!input || typeof input !== "string") return undefined;
    const s = input.trim();
    if (s.startsWith("rgba(")) return s;
    if (s.startsWith("rgb("))
      return s.replace(/^rgb\(/, "rgba(").replace(/\)$/, `, ${alpha})`);
    let h = s[0] === "#" ? s.slice(1) : s;
    if (h.length === 3)
      h = h
        .split("")
        .map((ch) => ch + ch)
        .join("");
    if (h.length !== 6 && h.length !== 8) return undefined;
    const r = parseInt(h.slice(0, 2), 16),
      g = parseInt(h.slice(2, 4), 16),
      b = parseInt(h.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  // --- Dates robustes (Africa/Algiers) ---

  // ✅ Mets true si ton backend renvoie des DATETIMEs naïfs (sans Z/offset) mais en réalité en UTC.
  // ❗ Mets false si ces DATETIMEs doivent être interprétés en heure d’Algérie.

  const tzParts = (input, tz = ConsultationConstants.CONSULTATION_TIME_ZONE) => {
    const d =
      input instanceof Date ? input : input ? new Date(input) : new Date();
    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: tz,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).formatToParts(d);
    const map = {};
    for (const p of parts) map[p.type] = p.value;
    return map; // {year, month, day, hour, minute, second}
  };

  const parseYMD = (s) => {
    const m = String(s).match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return null;
    const y = +m[1],
      mo = +m[2],
      d = +m[3];
    // On veut minuit ALG (UTC+1): si on interprète naïf en ALG,
    // UTC = ALG - 1h, donc heure UTC = -1
    const msUTC = Date.UTC(
      y,
      mo - 1,
      d,
      ConsultationConstants.SERVER_NAIVE_DATES_ARE_UTC ? 0 : -1,
      0,
      0,
    );
    return new Date(msUTC);
  };

  const parseNaiveDateTime = (s) => {
    const m = String(s).match(
      /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/,
    );
    if (!m) return null;
    const y = +m[1],
      mo = +m[2],
      d = +m[3],
      h = +m[4],
      mi = +m[5],
      se = +(m[6] ?? 0);
    if (ConsultationConstants.SERVER_NAIVE_DATES_ARE_UTC) {
      // interprète le naïf comme UTC
      return new Date(Date.UTC(y, mo - 1, d, h, mi, se));
    } else {
      // interprète le naïf comme heure ALG (UTC+1) => UTC = heure - 1
      return new Date(Date.UTC(y, mo - 1, d, h - 1, mi, se));
    }
  };

  const parseServerDate = (s) => {
    if (!s) return new Date();
    const str = String(s);
    if (/Z$|[+\-]\d{2}:\d{2}$/.test(str)) return new Date(str); // ISO avec fuseau
    const onlyYMD = parseYMD(str);
    if (onlyYMD) return onlyYMD;
    const naive = parseNaiveDateTime(str);
    if (naive) return naive;
    return ConsultationConstants.SERVER_NAIVE_DATES_ARE_UTC ? new Date(str + "Z") : new Date(str);
  };

  const toDate = (s) => (s instanceof Date ? s : parseServerDate(s));

  const dayKey = (s) => {
    const { year, month, day } = tzParts(s, ConsultationConstants.CONSULTATION_TIME_ZONE);
    return `${year}-${month}-${day}`; // "YYYY-MM-DD" en Africa/Algiers
    // NOTE: n'utilise pas new Date().getDate() ici: tzParts évite les décalages
  };

  const formatFR = (s) => {
    const { year, month, day } = tzParts(s, ConsultationConstants.CONSULTATION_TIME_ZONE);
    return `${day}-${month}-${year}`; // "DD-MM-YYYY"
  };
  // ==== Normalisation & couleurs ====
  const normColor = (c) =>
    typeof c === "string" && c.trim() && c.trim().toLowerCase() !== "null"
      ? c.trim()
      : null;

  const normalizeStep = (r) => {
    if (!r) return null;
    return {
      id: r.id ?? r._id,
      doctor_id: r.doctor_id ?? null,
      patient_id: r.patient_id ?? null,
      appointment_id: r.appointment_id ?? null,
      label: (r.label ?? r.service ?? r.nom ?? r.name ?? "").toString().trim(),
      color: normColor(r.color ?? r.couleur ?? null),
      done: !!(r.done ?? r.is_done ?? r.isDone),
      created_at: r.created_at ?? r.createdAt ?? null,
      // ➋ commentaire (selon comment s’appelle le champ côté API)
      comment: (r.comment ?? r.note ?? r.remarque ?? "").toString(),
    };
  };

  // --- états ---
  const [loadingProto, setLoadingProto] = React.useState(false);
  const [savingProto, setSavingProto] = React.useState({});
  const [protoMsg, setProtoMsg] = React.useState(null);

  const replaceItem = (arr = [], id, next) =>
    Array.isArray(arr)
      ? arr.map((x) => (String(x.id) === String(id) ? next : x))
      : [];

  // ==== Load protocole only when observations tab is active ====
  React.useEffect(() => {
    if (!DOC_doctorId || !DOC_patientId) return;
    if (activeTab !== "observations") return;

    let alive = true;
    (async () => {
      setLoadingProto(true);
      setProtoMsg(null);

      // Debug logging
      console.log("=== CARE STEPS LOADING DEBUG ===");
      console.log("📌 Appointment ID (DOC_appointmentId):", DOC_appointmentId);
      console.log("📌 Appointment ID (appId):", appId);
      console.log("👤 Patient ID (DOC_patientId):", DOC_patientId);
      console.log("🏥 Doctor ID (DOC_doctorId):", DOC_doctorId);
      console.log("📂 Active Tab:", activeTab);

      try {
        // Prepare parameters - don't pass appointmentId if it's null
        const params = {
          patientId: DOC_patientId,
          ...(DOC_appointmentId ? { appointmentId: DOC_appointmentId } : {}),
        };
        console.log("📤 Calling API with params:", params);

        const raw =
          typeof listDoctorProtocolsoinss === "function"
            ? await listDoctorProtocolsoinss(DOC_doctorId, params)
            : await listDoctorProtocolsoins(DOC_doctorId, params);

        console.log("📥 Raw care steps from API:", raw);
        console.log(
          "📊 Total care steps count:",
          Array.isArray(raw) ? raw.length : 0,
        );

        if (!alive) return;
        const rows = (Array.isArray(raw) ? raw : []).map(normalizeStep);

        // Debug: check if appointment_id is preserved
        if (rows.length > 0) {
          console.log("✅ First care step after normalizeStep:", rows[0]);
          console.log("🔗 Has appointment_id?", rows[0]?.appointment_id);
          console.log(
            "📌 Matches current appointment?",
            rows[0]?.appointment_id == DOC_appointmentId,
          );
        }

        rows.sort(
          (a, b) =>
            toDate(b.created_at) - toDate(a.created_at) ||
            (b.id ?? 0) - (a.id ?? 0),
        );

        console.log(
          "Care steps trouvés:",
          rows.length,
          "sur",
          rows.length,
          "total",
        );
        console.log(
          "Care steps with appointment_id:",
          rows.filter((s) => s.appointment_id).length,
        );

        setCareSteps(rows);
        console.log("=== FIN DEBUG ===");
      } catch (e) {
        console.error("Error loading care steps:", e);
        if (!alive) return;
        setProtoMsg("Échec de chargement du protocole.");
        setCareSteps([]);
      } finally {
        if (alive) setLoadingProto(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [DOC_doctorId, DOC_patientId, DOC_appointmentId, activeTab]);

  // (debug) vérifier quelques lignes
  React.useEffect(() => {
    if (Array.isArray(careSteps)) {
      console.debug("Sample steps:", careSteps.slice(0, 3));
    }
  }, [careSteps]);

  const [confirmDelete, setConfirmDelete] = React.useState(null); // {id, label} | null
  const [confirmBusy, setConfirmBusy] = React.useState(false);

  // ➊ État pour le commentaire inline
  const [editingCommentId, setEditingCommentId] = React.useState(null); // id en cours d'édition
  const [commentDraft, setCommentDraft] = React.useState(""); // valeur saisie

  // Petit helper si tu ne l'as pas déjà :
  function replaceItemm(list, id, next) {
    return (list || []).map((x) => (String(x.id) === String(id) ? next : x));
  }

  // Ouvre l'éditeur de commentaire pour une étape
  function openCommentEditor(step) {
    setEditingCommentId(step.id);
    setCommentDraft(step.comment || "");
  }

  // Ferme l'éditeur sans sauver
  function cancelCommentEdit() {
    setEditingCommentId(null);
    setCommentDraft("");
  }

  // ➌ Sauvegarde optimiste du commentaire
  async function saveStepComment(stepId) {
    const row = (careSteps || []).find((s) => String(s.id) === String(stepId));
    if (!row) return;

    const nextText = (commentDraft || "").trim();

    // ❶ Rien n'a changé → on ne fait rien
    if (nextText === (row.comment || "")) {
      cancelCommentEdit();
      return;
    }

    // ❷ Optimiste : met à jour localement
    const before = row;
    const after = { ...row, comment: nextText };
    setCareSteps((prev) => replaceItem(prev ?? [], stepId, after));
    setSavingProto((prev) => ({ ...(prev || {}), [stepId]: "commenting" }));

    try {
      // ⚠️ adapte la clé si ton backend attend autre chose que { comment: ... }
      const saved = await updateDoctorProtocolsoin(DOC_doctorId, stepId, {
        comment: nextText,
      });

      // Fusionne la réponse serveur (au cas où d'autres champs soient renvoyés)
      setCareSteps((prev) =>
        replaceItemm(prev ?? [], stepId, { ...after, ...(saved || {}) }),
      );

      setProtoMsg("Commentaire enregistré.");
      clearTimeout(window.__protoMsgTimer);
      window.__protoMsgTimer = setTimeout(() => setProtoMsg(null), 2000);
    } catch (e) {
      console.error(e);
      // ❸ Rollback en cas d'erreur
      setCareSteps((prev) => replaceItemm(prev ?? [], stepId, before));
      setProtoMsg("Échec d’enregistrement du commentaire.");
      clearTimeout(window.__protoMsgTimer);
      window.__protoMsgTimer = setTimeout(() => setProtoMsg(null), 3000);
    } finally {
      // ❹ Nettoyage de l'état "en cours"
      setSavingProto((prev) => {
        const { [stepId]: _ignore, ...rest } = prev || {};
        return rest;
      });
      cancelCommentEdit();
    }
  }


  // ==============================
  // Services + Hydratation Stocks
  // ==============================

  // --- ref des services (non rendu dans le JSX)
  const rowsRef = React.useRef([]);

  // on mémorise quels services ont déjà été “hydratés”
  const hydratedSet = React.useRef(new Set());
  // map: { [serviceId]: [{ stock_config_id, qty, parametre, code, available }, ...] }
  const hydratedStocks = React.useRef({});

  // ===== utils =====
  const safeStr = (v) => (v == null ? "" : String(v));
  const pick = (...vals) => vals.find((v) => v != null && v !== "");

  const authCfg = () => {
    try {
      const loginInfo = JSON.parse(
        localStorage.getItem("doctolikLoginInfo") || "null",
      );
      const token =
        loginInfo?.authorisation?.token ??
        loginInfo?.authorization?.token ??
        loginInfo?.token;

      return token
        ? {
          headers: {
            Authorization: `Bearer ${token}`,
            "Cache-Control": "no-cache",
          },
        }
        : {};
    } catch {
      return {};
    }
  };

  // mappe un service renvoyé par l’API → objet local minimal (+ lien stock éventuel)
  function mapServerService(s) {
    return {
      id: Number(s.id),
      name: safeStr(pick(s.name, s.service, s.label, s.titre, s.nom)),
      color: s.color ?? s.couleur ?? null,

      // si l’API services renvoie déjà une piste stock + quantité unitaire
      stockSearch: safeStr(
        pick(
          s.stock_parametre,
          s.stock_name,
          s.stock,
          s.parametre,
          s.code,
          s.ref,
        ),
      ),
      stockQty: Number(pick(s.stock_qty, s.qty, s.quantite, 1)) || 1,
    };
  }

  // fusionne en conservant l’ordre existant (par id)
  function mergeStableOrder(prev, incoming) {
    const seen = new Set();
    const out = [];
    for (const p of prev) {
      const k = String(p.id);
      const newer = incoming.find((x) => String(x.id) === k);
      out.push(newer || p);
      seen.add(k);
    }
    for (const n of incoming) {
      const k = String(n.id);
      if (!seen.has(k)) out.push(n);
    }
    return out;
  }

  // ================
  // 1) Charger rows
  // ================
  async function loadRows() {
    if (!DOC_doctorId) return;
    const url = `${API_BASE_URL}doctor/${DOC_doctorId}/services`;
    try {
      const { data } = await axios.get(url, authCfg());
      const list = Array.isArray(data?.data)
        ? data.data
        : Array.isArray(data)
          ? data
          : [];
      const incoming = (list || []).map(mapServerService);
      rowsRef.current = rowsRef.current.length ? mergeStableOrder(rowsRef.current, incoming) : incoming;
    } catch (e) {
      console.error("[services] loadRows failed", e?.response?.data || e);
    }
  }

  // ==========================
  // Effets d’initialisation
  // ==========================
  React.useEffect(() => {
    hydratedSet.current = new Set();
    hydratedStocks.current = {};
    rowsRef.current = [];
    if (!DOC_doctorId) return;
    (async () => {
      await loadRows();
    })();
  }, [DOC_doctorId]);








  /*****************************************************
   * AJOUT d’une étape (débit exact des stocks liés)
   * — si l’article existe déjà dans "stock utilisé", on INCRÉMENTE
   *****************************************************/

  /* ========================= Helpers Prix (fiables) ========================= */
  function ymdLocal(d = new Date()) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  }

  /* ===================== STATE ===================== */

  const [loading, setLoading] = React.useState(false);

  /* ===== Helpers: extraire remark d’annulation & montant ===== */

  function safeColor(c) {
    const v = String(c || "").trim();
    if (!/^#([0-9a-f]{6}|[0-9a-f]{3})$/i.test(v)) return "#35a103";
    if (v.length === 4)
      return ("#" + v[1] + v[1] + v[2] + v[2] + v[3] + v[3]).toUpperCase();
    return v.toUpperCase();
  }

  function toYear(dateStr) {
    return String(dateStr || "").slice(0, 4) || "";
  }

  function cryptoRandomId() {
    if (typeof globalThis !== "undefined" && globalThis.crypto?.randomUUID) {
      return globalThis.crypto.randomUUID();
    }
    return (
      "tl_" + Math.random().toString(36).slice(2) + Date.now().toString(36)
    );
  }

  /* Récupère la vraie date d’évènement (YYYY-MM-DD) */
  function getEventDate(x) {
    return String(x?.event_date ?? x?.date ?? "");
  }
  /* Tri DESC par event_date, puis id DESC */
  function cmpByEventDateDesc(a, b) {
    const ad = getEventDate(a);
    const bd = getEventDate(b);
    if (ad !== bd) return bd.localeCompare(ad);
    return String(b?.id ?? "").localeCompare(String(a?.id ?? ""));
  }



  /* Images helpers */
  function normalizeImages(any) {
    if (!any) return [];
    const arr = Array.isArray(any)
      ? any
      : typeof any === "string"
        ? any.split(",")
        : [];
    return arr
      .map((it, i) => {
        if (typeof it === "string")
          return { id: `img_${i}_${cryptoRandomId()}`, url: it.trim() };
        if (it && typeof it === "object" && it.url)
          return {
            id: it.id || `img_${i}_${cryptoRandomId()}`,
            url: String(it.url),
          };
        return null;
      })
      .filter(Boolean);
  }

  /* ===================== State ===================== */

  const [showAdd, setShowAdd] = React.useState(false)

  /* Bloquer le scroll de la page quand la popup Ajout est ouverte */
  React.useEffect(() => {
    if (showAdd) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [showAdd]);

  const [selectedModel, setSelectedModel] = useState("medgemma"); // valeur par défaut


  // Reload care steps when the Medical Report modal opens.
  useEffect(() => {
    if (!showMedicalReport) return;
    (async () => {
      try {
        if (
          DOC_doctorId &&
          DOC_patientId &&
          selectedObservationItem?.appointment_id
        ) {
          const selectedAppointmentId = selectedObservationItem?.appointment_id;

          const raw =
            typeof listDoctorProtocolsoinss === "function"
              ? await listDoctorProtocolsoinss(DOC_doctorId, {
                patientId: DOC_patientId,
                appointmentId: selectedAppointmentId,
              })
              : await listDoctorProtocolsoins(DOC_doctorId, {
                patientId: DOC_patientId,
                appointmentId: selectedAppointmentId,
              });

          const rows = (Array.isArray(raw) ? raw : []).map((step) => {
            const normalized = normalizeStep(step);
            return {
              ...normalized,
              appointment_id: selectedAppointmentId,
            };
          });

          rows.sort(
            (a, b) =>
              toDate(b.created_at) - toDate(a.created_at) ||
              (b.id ?? 0) - (a.id ?? 0),
          );
          setCareSteps(rows);
        }
      } catch (err) {
        // silently fail
      }
    })();
  }, [showMedicalReport]);


  const [chatHistory, setChatHistory] = useState(() => {
    try {
      const saved = localStorage.getItem(`cobot_history_${patientId}`);
      return saved ? JSON.parse(saved) : [];
    } catch (e) {
      return [];
    }
  });

  const inlineCobotRef = useRef(null);

  // Auto-scroll to bottom for inline cobot
  useEffect(() => {
    if (inlineCobotRef.current) {
      inlineCobotRef.current.scrollTop = inlineCobotRef.current.scrollHeight;
    }
  }, [chatHistory, showCobotBox]);

  // Save chatHistory to localStorage whenever it changes
  useEffect(() => {
    if (patientId) {
      localStorage.setItem(`cobot_history_${patientId}`, JSON.stringify(chatHistory));
    }
  }, [chatHistory, patientId]);

  const profileChatApiii = (payload, doctorId, patientId) => {
    if (!doctorId || !patientId)
      return Promise.reject(new Error("Missing doctor or patient id"));

    // Utiliser l'URL de base dynamique au lieu de localhost
    const url = `${API_BASE_URL}doctors/${doctorId}/patients/${patientId}/profile-chat-full`;

    // Récupérer le token d'authentification de manière robuste
    let authHeaders = {};
    try {
      const loginInfo = JSON.parse(localStorage.getItem("doctolikLoginInfo"));
      const token = loginInfo?.authorisation?.token || loginInfo?.token;
      if (token) {
        authHeaders = { Authorization: `Bearer ${token}` };
      }
    } catch (e) {
      console.warn("Could not get auth token for Cobot API", e);
    }

    return axios.post(url, payload, {
      headers: {
        "Content-Type": "application/json",
        ...authHeaders,
      },
      timeout: 200000,
    });
  };

  // normalize axios/fetch responses to a usable object
  const normalizeApiResponse = (resp) => {
    // axios response shape: { data, status, ...}
    if (!resp) return null;
    if (resp?.data !== undefined) return resp.data;
    return resp;
  };

  const extractTextFromApi = (respObj) => {
    if (!respObj) return null;
    if (typeof respObj === "string") return respObj;
    if (typeof respObj === "object") {
      // common places to look
      return (
        respObj.message ||
        respObj.message_text ||
        respObj.assistant ||
        respObj.text ||
        respObj.data ||
        respObj.output_text ||
        respObj.content ||
        respObj.proxy?.choices?.[0]?.message?.content ||
        null
      );
    }
    return null;
  };

  const fetchAndStoreFullHistory = async () => {
    if (!doctorId || !patientId) return;
    try {
      const sid =
        sessionId || localStorage.getItem(`${ConsultationConstants.MEDGEMMA_STORAGE_PREFIX}session_id`);
      const payload = {
        session_id: sid || null,
        message: "Generate patient profile block",
      };
      const resp = await profileChatApiii(payload, doctorId, patientId);
      const normalized = normalizeApiResponse(resp);
      if (normalized?.session_id) {
        setSessionId(normalized.session_id);
        localStorage.setItem(
          `${ConsultationConstants.MEDGEMMA_STORAGE_PREFIX}session_id`,
          normalized.session_id,
        );
      }
      const text = extractTextFromApi(normalized);
      if (text) {
        const cleanedText = text
          .replace(
            /I received your message but encountered an issue with the response format\./g,
            "",
          )
          .trim();
        const finalSid =
          normalized.session_id ||
          sessionId ||
          localStorage.getItem(`${ConsultationConstants.MEDGEMMA_STORAGE_PREFIX}session_id`);
        if (finalSid)
          localStorage.setItem(
            `${ConsultationConstants.MEDGEMMA_STORAGE_PREFIX}last_profile_${finalSid}`,
            cleanedText,
          );
        console.log("Full patient history fetched and stored for Cobot");
      }
    } catch (err) {
      console.error("Error fetching full history for Cobot:", err);
    }
  };

  const handleSendCobot = async () => {
    if (!cobotText.trim()) return;

    const userMessage = { role: "user", text: cobotText };
    const newHistory = [...chatHistory, userMessage];
    setChatHistory(newHistory);
    setCobotText("");
    setLoading(true);

    if (!doctorId || !patientId) {
      console.error("Doctor ID or Patient ID is missing:", {
        doctorId,
        patientId,
      });
      setChatHistory((prev) => [
        ...prev,
        { role: "assistant", text: "Erreur : doctorId ou patientId manquant." },
      ]);
      setLoading(false);
      return;
    }

    try {
      // Retrieve saved profile or fetch it if missing
      let profileText = null;
      const sid =
        sessionId || localStorage.getItem(`${ConsultationConstants.MEDGEMMA_STORAGE_PREFIX}session_id`);

      try {
        if (sid)
          profileText =
            localStorage.getItem(`${ConsultationConstants.MEDGEMMA_STORAGE_PREFIX}last_profile_${sid}`) ||
            null;
      } catch (e) {
        console.warn("Error reading last profile from storage", e);
      }

      // Fetch the profile in the background; do not delay the first answer.
      if (!profileText) {
        console.log("Profile missing in storage, fetching now...");
        void fetchAndStoreFullHistory();
      }

      // Final check/clean of profileText even if it came from storage
      if (profileText) {
        profileText = profileText
          .replace(
            /I received your message but encountered an issue with the response format\./g,
            "",
          )
          .trim();
        if (profileText.length > 6000) {
          profileText =
            profileText.substring(0, 6000) +
            "\n\n[Historique tronqué pour cause de longueur...]";
        }
      }

      // Build conversation history for the AI
      const historyContext = newHistory
        .map((m) => `${m.role === "user" ? "Médecin" : "Assistant"}: ${m.text}`)
        .join("\n");

      const combinedMessage = profileText
        ? `CONTEXTE SYSTÈME : Tu es MedGemma, un assistant médical expert intégré dans un logiciel de gestion de cabinet. Tu as accès au dossier complet du patient. 
IMPORTANT : Ne donne JAMAIS de message d'avertissement générique comme "Je ne peux pas diagnostiquer" ou "Consultez un médecin". L'utilisateur EST un médecin qui utilise tes services pour l'aider dans son analyse clinique.
Réponds de manière concise, directe et professionnelle en te basant EXCLUSIVEMENT sur l'historique fourni ci-dessous. 
Si le médecin pose une question sur une condition spécifique (ex: abcès, asthme, etc.), vérifie d'abord si cela apparaît dans les antécédents ou les consultations passées.

Voici l'historique médical du patient :
${profileText}

Historique de la discussion :
${historyContext}

Dernière question du médecin : ${userMessage.text}`
        : `Historique de la discussion :
${historyContext}

Dernière question du médecin : ${userMessage.text}`;

      console.debug("Sending cobot request", { hasProfile: !!profileText });

      // Use existing wrapper which should respect backend/session handling
      const data = await callOpenAIBackend({
        message: combinedMessage,
        model: "gpt-5-nano",
      });

      console.debug("Cobot raw response", data);

      // Check if data is the request payload (bug fix for JSON display)
      if (
        data &&
        data.message === combinedMessage &&
        !data.output_text &&
        !data.text
      ) {
        throw new Error(
          "Le serveur a renvoyé la requête au lieu d'une réponse.",
        );
      }

      const assistantText =
        data.output_text ?? data.raw?.output_text ?? data.text ?? null;

      if (data?.session_id) {
        try {
          setSessionId(data.session_id);
          localStorage.setItem(
            `${ConsultationConstants.MEDGEMMA_STORAGE_PREFIX}session_id`,
            data.session_id,
          );
        } catch (e) { }
      }

      if (!assistantText) {
        setChatHistory((prev) => [
          ...prev,
          { role: "assistant", text: "Erreur serveur : réponse non valide" },
        ]);
      } else {
        setChatHistory((prev) => [
          ...prev,
          { role: "assistant", text: assistantText },
        ]);
      }
    } catch (err) {
      console.error("Erreur réseau ou serveur :", err);
      setChatHistory((prev) => [
        ...prev,
        { role: "assistant", text: "Erreur réseau ou serveur : " + err.message },
      ]);
    } finally {
      setLoading(false);
    }
  };




  return (
    <div className="doctormain appointment-details-page">
      <Sidebar />
      <div className="rightSec">
        {/* Custom Header with Search Patient and Profile Dropdown */}

        {screenLoading && <LoadingPage />}

        {/* (COBOT top fixed box removed — new inline COBOT top section inserted below near medical background) */}

        <ConsultationHeader
          appointment={appointmentDetails}
          navigation={{
            previousId: allAppDetails?.previousId,
            nextId: allAppDetails?.nextId,
          }}
          profile={{
            firstName: userData?.users?.first_name,
            lastName: userData?.users?.last_name,
            pictureUrl: userData?.users?.profile_pic_url,
          }}
          isProfileOpen={isProfileDropdownOpen}
          onNavigate={navigate}
          onToggleProfile={() =>
            setIsProfileDropdownOpen((isOpen) => !isOpen)
          }
          onLogout={() => {
            onLogout();
            setUserData(null);
          }}
        />

        <div className="RoxBox appointmentDetailsRoxBox2">
          <div className="LftDoctorConsultationObservations">
            <PatientInformationsWidget
              appointmentDetails={appointmentDetails}
              screenLoading={screenLoading}
              setChoosePatientConfirmPopup={setChoosePatientConfirmPopup}
              setSelectedKidDetails={setSelectedKidDetails}
              toggleProfileMoadl={toggleProfileMoadl}
              allAppDetails={allAppDetails}
              handleChangePriority={handleChangePriority}
              handleChangePrioritySupport={handleChangePrioritySupport}
              handleTabClick={handleTabClick}
            />

            {/* Medical Condition Widget  */}

            <div className="Accordion">
              <MedicalConditionWidget
                medicalCondToggle={medicalCondToggle}
                setMedicalCondToggle={setMedicalCondToggle}
                activeIndexes={activeIndexes}
                toggleAccordion={toggleAccordion}
                setShowCobotBox={setShowCobotBox}
                showCobotBox={showCobotBox}
                fetchAndStoreFullHistory={fetchAndStoreFullHistory}
                chatHistory={chatHistory}
                setChatHistory={setChatHistory}
                patientId={patientId}
                doctorId={DOC_doctorId}
                appId={appId}
                appointmentId={appId}
                chartPoints={chartPoints}
                showMedicalReport={showMedicalReport}
                inlineCobotRef={inlineCobotRef}
                loading={loading}
                cobotText={cobotText}
                setCobotText={setCobotText}
                handleSendCobot={handleSendCobot}
                toggleMedicalReport={toggleMedicalReport}
                setSelectedObservationItem={setSelectedObservationItem}
                selectedObservationItem={selectedObservationItem}
                moment={moment}
                allAppDetails={allAppDetails}
                selectedObservationPrescriptions={selectedObservationPrescriptions}
                isOrdonnanceLegacyItem={isOrdonnanceLegacyItem}
                selectedObservationPrescriptorModels={selectedObservationPrescriptorModels}
                buildLegacyModelLines={buildLegacyModelLines}
                looksLikeHtml={looksLikeHtml}
                careSteps={careSteps}
                modalChartLoading={modalChartLoading}
                modalChartData={modalChartData}
              />
              {/* Medical background widget */}

              <MedicalBackgroundWidget
                activeIndexes={activeIndexes}
                toggleAccordion={toggleAccordion}
                appointmentDetails={appointmentDetails}
                doctorId={DOC_doctorId}
                patientId={DOC_patientId}
                appId={appId}
              />

            </div>
          </div>
          {!screenLoading ? (
            <div className="RghtDoctorConsultationObservations">
              <div className="Card">
                <ConsultationToolbar
                  activeTab={activeTab}
                  appointment={appointmentDetails}
                  actionsDisabled={isPreviousDateFromCurrent(
                    appointmentDetails?.appointment_date,
                  )}
                  isLoading={screenLoading}
                  onTabChange={handleTabClick}
                  onReadMessages={handleReadMesssage}
                  onToggleChat={toggleChat}
                  recorder={recorder}
                  onFinish={() => setShowDeletePopup(true)}
                  onReschedule={() => {
                    setReschedulePopupShow(true);
                    dispatch(setRescheduleModalOpen(true));
                    setShowManageDropdown(false);
                  }}
                  onCancel={() => {
                    toggleCancelAppointmnet();
                    setShowManageDropdown(false);
                  }}
                  onMarkAbsent={() => {
                    handleStatusChange("absent");
                    setShowManageDropdown(false);
                  }}
                />
                <div
                  className="TabContentSection"
                  style={{
                    flex: "1",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {/* Tab Content with Suspense for lazy loading */}
                  <Suspense
                    fallback={
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "400px",
                        }}
                      >
                        <div style={{ fontSize: "18px", color: "#666" }}>
                          Loading...
                        </div>
                      </div>
                    }
                  >
                    {activeTab === "observations" && (
                      <ObservationsTab
                        // Appointment & Patient Data
                        appointmentId={appId}
                        appointmentDetails={appointmentDetails}
                        allAppDetails={allAppDetails}
                        readOnly={readOnly}
                        doctorId={doctorId}
                        patientId={patientId}
                        // Medical Condition Title
                        medicalCondTitle={medicalCondTitle}
                        setMedicalCondTitle={setMedicalCondTitle}

                        diagInputRef={diagInputRef}
                        diagPanelRef={diagPanelRef}
                        chooseDiagTitle={chooseDiagTitle}
                        fetchDiagTitles={fetchDiagTitles}
                        diagTitles={diagTitles}
                        // Editor States & Refs
                        editor={editor}
                        editor2={editor2}
                        reminderNoteEditorRef={reminderNoteEditorRef}
                        examinationContent={examinationContent}
                        setExaminationContent={setExaminationContent}
                        otherNotesContent={otherNotesContent}
                        setOtherNotesContent={setOtherNotesContent}
                        reminderNotesContent={reminderNotesContent}
                        setReminderNotesContent={setReminderNotesContent}
                        joditConfigExamination={joditConfigExamination}
                        joditConfigOtherNotes={joditConfigOtherNotes}
                        joditConfigReminderNotes={joditConfigReminderNotes}
                        normalizeEmptyHtml={normalizeEmptyHtml}
                        // Quick Bar
                        editorWrapRef={editorWrapRef}
                        contentScrollRef={contentScrollRef}
                        quickBarRef={quickBarRef}
                        quickValue={quickValue}
                        onQuickChange={onQuickChange}
                        onQuickKeyDown={onQuickKeyDown}
                        onQuickSubmit={onQuickSubmit}
                        clearQuick={clearQuick}
                        quickSuggestions={quickSuggestions}
                        quickListRect={quickListRect}
                        quickActive={quickActive}
                        selectQuick={selectQuick}
                        // Panel Suggestions
                        showPanel={showPanel}
                        panelSuggestions={panelSuggestions}
                        panelPos={panelPos}
                        panelRef={panelRef}
                        activeIndex={activeIndex}
                        setActiveIndex={setActiveIndex}
                        insertExamItem={insertExamItem}
                        examQuick={examQuick}
                        recorder={recorder}
                        // Emoji Pickers
                        showEmojiPicker1={showEmojiPicker1}
                        setShowEmojiPicker1={setShowEmojiPicker1}
                        emojiPickerRef2={emojiPickerRef2}
                        // Prev Values & Handler
                        prevValues={prevValues}
                        setPrevValues={setPrevValues}
                        // Protocol de soin (Care Steps)
                        loadingProto={loadingProto}
                        protoMsg={protoMsg}
                        setProtoMsg={setProtoMsg}
                        setConfirmDelete={setConfirmDelete}
                        confirmDelete={confirmDelete}
                        confirmBusy={confirmBusy}
                        setConfirmBusy={setConfirmBusy}
                        formatFR={formatFR}
                        dayKey={dayKey}
                        withAlpha={withAlpha}
                        textColorOn={textColorOn}
                        openCommentEditor={openCommentEditor}
                        editingCommentId={editingCommentId}
                        commentDraft={commentDraft}
                        setCommentDraft={setCommentDraft}
                        saveStepComment={saveStepComment}
                        cancelCommentEdit={cancelCommentEdit}
                        isPeriodicVisit={isPeriodicVisit}
                        setIsPeriodicVisit={setIsPeriodicVisit}
                        // Stock utilisé
                        safeColor={safeColor}
                        ymdLocal={ymdLocal}
                        // Finish Modal
                        // Docs Toggle
                        docsVisible={docsVisible}
                        setDocsVisible={setDocsVisible}
                        setScrollLocked={setScrollLocked}
                      // Chart Points Callback
                      />
                    )}

                    {activeTab === "new-prescriptor" && (
                      <NewPrescriptorTab
                        key={appId}
                        appointmentId={appId}
                        patientId={
                          appointmentDetails?.patient_details?.[0]?.id ||
                          allAppDetails?.data?.[0]?.patient_details?.[0]?.id ||
                          ""
                        }
                        patientName={
                          prescriptionDate?.name ||
                          `${appointmentDetails?.patient_details?.[0]?.first_name || ""} ${appointmentDetails?.patient_details?.[0]?.last_name || ""}`.trim()
                        }
                        patientAge={
                          prescriptionDate?.age ||
                          appointmentDetails?.patient_details?.[0]?.age ||
                          ""
                        }
                        patientBirthDate={
                          appointmentDetails?.patient_details?.[0]?.dob ||
                          allAppDetails?.data?.[0]?.patient_details?.[0]?.dob ||
                          ""
                        }
                        patientSex={
                          prescriptionDate?.gender ||
                          appointmentDetails?.patient_details?.[0]?.gender ||
                          ""
                        }
                        patientAddress={
                          appointmentDetails?.patient_details?.[0]
                            ?.patient_address ||
                          allAppDetails?.data?.[0]?.patient_details?.[0]
                            ?.patient_address ||
                          ""
                        }
                      />
                    )}

                    {activeTab === "message" && (
                      <MessageTab
                        // User Data
                        userData={userData}
                        // Appointment Details
                        appointmentDetails={appointmentDetails}
                        appId={appId}
                        doctorId={doctorId}
                        patientId={patientId}
                        // Utils
                        chatMessgaeDateFormat={chatMessgaeDateFormat}
                        getFileExtension={getFileExtension}
                        // Doctor Search Modal
                        setShowToDoctorModal={setShowToDoctorModal}
                        setShowReferDoctorModal={setShowReferDoctorModal}
                        // Handlers from parent
                        handleOpenReferPopup={handleOpenReferPopup}
                        // Message Data from parent
                        messageList={messageList}
                        setMessageList={setMessageList}
                        messageText={messageText}
                        setMessageText={setMessageText}
                        messageFile={messageFile}
                        setMessageFile={setMessageFile}
                        messageSending={messageSending}
                        setMessageSending={setMessageSending}
                        messageSenderObj={messageSenderObj}
                        setMessageSenderObj={setMessageSenderObj}
                        toDoctorSearchText={toDoctorSearchText}
                        setToDoctorSearchText={setToDoctorSearchText}
                        toDoctorSearchList={toDoctorSearchList}
                        setToDoctorSearchList={setToDoctorSearchList}
                        toDoctorAndReferList={toDoctorAndReferList}
                        setToDoctorAndReferList={setToDoctorAndReferList}
                        getDoctorForSearch={getDoctorForSearch}
                        // API function
                        getAppointmentMessage={getAppointmentMessage}
                      />
                    )}

                    {/* ============ PAYMENT MANAGEMENT ============ */}
                    {activeTab === "payment-management" && (
                      <PaymentManagementTab
                        appointmentId={appId}
                        patientId={appointmentDetails?.patient_details?.[0]?.id}
                      />
                    )}

                    {activeTab === "cobot" && (
                      <CobotTab
                        doctorId={DOC_doctorId}
                        patientId={DOC_patientId}
                        patientAge={
                          appointmentDetails?.patient_details?.[0]?.age ?? ""
                        }
                        patientGender={
                          appointmentDetails?.patient_details?.[0]?.gender ?? ""
                        }
                      />
                    )}
                  </Suspense>
                </div>
              </div>
            </div>
          ) : null}
        </div>

        {<AddFamilyMemberModal
          show={showProfileModal}
          onClose={() => setShowProfileModal(false)}
          addPatientObject={addPatientObject}
          setAddPatientObject={setAddPatientObject}
          months={months}
          daysarray={daysarray}
          years={years}
          popupBtnDis={popupBtnDis}
          onSubmit={handleAddKid}
        />}

        <ChangePhoneNumberModal
          isOpen={showChangePhoneModal}
          phoneNumber={newPhoneNumber}
          onPhoneNumberChange={setNewPhoneNumber}
          onClose={() => setShowChangePhoneModal(false)}
          onSubmit={handleChangePhoneNumber}
          isSubmitting={popupBtnDis}
        />
        {/* TODO need to be removed  */}
        {/* <ConfirmationModal
          isOpen={showRemoveIndicator}
          message={
            <>
              Are you want to delete the (
              {selectedIndicatorForEdit?.category_name}) indicators to follow?
            </>
          }
          onClose={toggleRemoveIndicator}
          onConfirm={handleRemoveIndicator}
          isConfirming={popupBtnDis}
        /> */}
        <ConfirmationModal
          isOpen={showRemoveMedicalBackgroundItem}
          message="Are you want to delete the Allergies (Pénicilline)?"
          onClose={toggleRemoveMedicalBackgroundItem}
          onConfirm={toggleRemoveMedicalBackgroundItem}
        />
        <RemindersModal
          isOpen={showRemindersModal}
          reminderHtml={
            allAppDetails?.previousObservations?.reminder_note
          }
          onClose={toggleRemindersModal}
        />
        <PrescriptionTemplateModal
          isOpen={showTemplateModal}
          title="Use Templates"
          selectedTemplateId={selectedTemplateId}
          onSelectTemplate={(item) => {
            handleTemplateTabChange(item);
          }}
          onClose={toggleTemplateModal}
          closeOnSelect={true}
        />
        <ReferTemplateModal
          isOpen={showReferTemplateModal}
          templates={referTemplateList}
          selectedTemplateId={selectedReferTemplate}
          isSubmitting={popupBtnDis}
          onClose={() => {
            setShowReferTemplateModal(false);
            setSeletedReferTemplate(null);
            setReferTemplateMessage("");
            setReferTextTemplateMessage("");
          }}
          onSelect={setSeletedReferTemplate}
          onPrint={handlePintReferTemplate}
        />
        <AppointmentCancellationModal
          isOpen={showCancelAppointmnet}
          reason={cancelReason}
          isSubmitting={modalBtnDis}
          onReasonChange={(reasonVal) => {
            setCancelReason(reasonVal);
            dispatch(setSelectedCancelReason(reasonVal));
          }}
          onClose={toggleCancelAppointmnet}
          onSubmit={handleCancelAppointment}
        />
        <DoctorSearchModal
          isOpen={showReferDoctorModal}
          title="Refer a doctor"
          searchText={toDoctorSearchText}
          results={toDoctorSearchList}
          isLoading={toDoctorSearchLoader}
          actionLabel="Refer"
          allowCustomDoctor
          onSearchChange={handleToDoctorSearchTextChange}
          onClose={toggleReferDoctor}
          onSelect={(doctor) =>
            handleSelectMessageSender("refer-to", doctor || "")
          }
        />
        <DoctorSearchModal
          isOpen={showToDoctorModal}
          title="Message to Doctor"
          searchText={toDoctorSearchText}
          results={toDoctorSearchList}
          isLoading={toDoctorSearchLoader}
          actionLabel="Select"
          onSearchChange={handleToDoctorSearchTextChange}
          onClose={() => setShowToDoctorModal(false)}
          onSelect={(doctor) =>
            handleSelectMessageSender("to-doctor", doctor)
          }
        />
        <RescheduleAppointmentModal
          isOpen={reschedulePopupShow}
          calendarValue={calendarValue}
          availableDates={availDates}
          futureDate={futureDate}
          selectedTime={selectedTime}
          reason={rescheduleReason}
          isLoadingSlots={skelLoading}
          isSubmitting={modalBtnDis}
          onClose={() => {
            setReschedulePopupShow(false);
            dispatch(setRescheduleModalOpen(false));
          }}
          onDateChange={handleDateClick}
          onActiveStartDateChange={handleActiveStartDateChange}
          tileClassName={tileClassName}
          onSelectTime={handleSelectTime}
          generateTimeSlots={generateTimeSlots}
          onReasonChange={(reasonVal) => {
            setRescheduleReason(reasonVal);
            dispatch(setSelectedRescheduleReason(reasonVal));
          }}
          onSubmit={handleReschedule}
        />
        <PopupConfirmationModal
          isOpen={showDeleteTempPopup}
          message="Are you sure you want to remove this template?"
          onClose={() => setShowDeleteTempPopup(false)}
          onConfirm={handleTemplateDelete}
        />
        <PopupConfirmationModal
          isOpen={choosePatientConfirmPopup}
          message={
            <>
              Are you sure you want to choose kid{" "}
              <span className="childName">
                {selectedKidDetails?.first_name}{" "}
                {selectedKidDetails?.last_name}
              </span>
              ?
            </>
          }
          isConfirming={popupBtnDis}
          onClose={() => {
            setChoosePatientConfirmPopup(false);
            setSelectedKidDetails(null);
          }}
          onConfirm={handleSelectKid}
        />
        <AbsenceModal
          isOpen={absensePopupOpen}
          reason={absenseReason}
          isSubmitting={modalBtnDis}
          onClose={() => {
            setAbsensePopupOpen(false);
            dispatch(setAbsenceModalOpen(false));
          }}
          onReasonChange={(reasonVal) => {
            setAbsenseReason(reasonVal);
            dispatch(setSelectedAbsenceReason(reasonVal));
          }}
          onSubmit={markAbsentSubmit}
        />
        <FinishAppointmentModal
          isOpen={showDeletePopup}
          isSubmitting={deleteBtnDis}
          onClose={() => setShowDeletePopup(false)}
          onConfirm={handleAppIsFinished}
        />

        <CobotModal
          isOpen={showCobotModal}
          text={cobotText || ""}
          messages={chatHistory}
          isLoading={loading}
          conversationRef={inlineCobotRef}
          onClose={() => setShowCobotModal(false)}
          onResetAndClose={() => {
            setShowCobotModal(false);
            setCobotText("");
            setChatHistory([]);
            if (patientId) {
              localStorage.removeItem(`cobot_history_${patientId}`);
            }
          }}
          onTextChange={setCobotText}
          onSend={handleSendCobot}
        />
      </div>
    </div>
  );
};

export default ConsultationObservations;
